import React, { useEffect, Fragment, useMemo } from "react";
import Loader from "../../../../components/styled-components/loader/loader";
import { MODULE_API } from "../../../../apis";
import { useState } from "react";
import DropDown from "../../../../components/styled-components/dropdown/dropdown";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import ROUTES from "../../../../config/routes";
import {
  Radio,
  DatePicker,
  Button,
  Collapse,
  Select,
  Spin,
  Modal,
  InputNumber,
  AutoComplete,
  Input,
} from "antd";
import * as Styles from "./styles/allocationSubFormStyles";
import ExpandedRowRender from "./ExpandedRowRender";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import AssetListing from "../asset-listing/Asset-Listing";
import swal from "sweetalert";
import Currency from "../../../../components/form/Currency";
import CurrencyCosts from "../../../../components/form/CurrencyForAssets";
import helpIcon from "../../../../assets/images/DeathModuleNew/IC_Help.png";
import List from "../../../../newComponents/styledComponents/Table/List";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
import addIcon1 from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { Table, Menu, Icon, Dropdown as DropDown1 } from "antd";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import axios from "axios";
import TAX_AND_INFLATION_API from "../../../../apis/tax_and_inflation.api";
import { ToolTipCreator } from "../../../../helpers/ToolTipCreator";
import FETCH from "../../../../utils/fetch";
import { AddOwnerModal } from "../../../../newComponents/ManageOwners/component/AddOwnerModal";

const { Option } = Select;
const Options = AutoComplete.Option;

const AllocationSubform = () => {
  let tabs2;
  const AllTabs = {
    "ASSET INFORMATION": {
      name: "ASSET INFORMATION",
      enabled: false,
      priority: 1,
    },
    "QUALIFIED ACCOUNT TYPE QUESTIONS": {
      name: "QUALIFIED ACCOUNT TYPE QUESTIONS",
      enabled: false,
      priority: 2,
    },
    "CONTRIBUTIONS OR DISTRIBUTIONS": {
      name: "CONTRIBUTIONS OR DISTRIBUTIONS",
      enabled: false,
      priority: 3,
    },
    "ADDITIONAL ASSET INFORMATION": {
      name: "ADDITIONAL ASSET INFORMATION",
      enabled: false,
      priority: 4,
    },
    "SELLING ASSET COSTS": {
      name: "SELLING ASSET COSTS",
      enabled: false,
      priority: 5,
    },
    "ASSET PERFORMANCE": {
      name: "ASSET PERFORMANCE",
      enabled: false,
      priority: 6,
    },
    "TAX AND LIQUIDITY": {
      name: "TAX AND LIQUIDITY",
      enabled: false,
      priority: 7,
    },
  };

  const desiredOrder = [
    "ASSET INFORMATION",
    "QUALIFIED ACCOUNT TYPE QUESTIONS",
    "CONTRIBUTIONS OR DISTRIBUTIONS",
    "ADDITIONAL ASSET INFORMATION",
    "SELLING ASSET COSTS",
    "Asset Performance",
    "Tax and Liquidity",
  ];

  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  const { view } = useParams();
  console.log("module", module, id);
  let module111 = module;
  // --------------------states---------------
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);

  const [loading, setIsLoading] = useState(false);
  const [loadingFields, setLoadingFields] = useState(false);

  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("ASSET INFORMATION");
  const [activeStep1, setActiveStep1] = useState(0);
  const [submitBody, setSubmitBody] = useState({});
  const [stocksToCreate, setStocksToCreate] = useState(null);
  const [originalStocks, setOriginalStocks] = useState(null);
  const [fieldsData, setFieldsData] = useState({});

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  //   ---------------functions----------------------
  const getAssetFields = async (assetName) => {
    setIsLoading(true);
    console.log("assetName....", assetName);
    const res = await MODULE_API.assetFiledDetails(assetName);
    setIsLoading(false);
    console.log("result....", res);
    res &&
      res.attributes &&
      res.attributes.map((attribute) => {
        setFields((prevValue) => {
          return {
            ...prevValue,
            [attribute["groupName"]]: {
              ...(prevValue[attribute["groupName"]] || {}),
              [attribute["id"]]: attribute,
            },
          };
        });
      });
  };
  const getAssetFieldsData = async (id) => {
    setIsLoading(true);
    setLoadingFields(true);
    console.log("asset id....", id);
    const res = await MODULE_API.fetchDetails(id);
    if (res && res.data) {
      setFieldsData(res.data);
      console.log("result....", res);
    }
    setIsLoading(false);
    setLoadingFields(false);
  };
  function handlePreviousFormButton() {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a - 1];
    setActiveTabName(tabsControl[b]);
    setActiveStep1(a - 1);
  }
  function tabsPrevNextControl() {
    let temp = Object.keys(AllTabs);
    tabs2 = tabs.map((tab) => tab.toUpperCase());
    let obj = {};
    tabs2.map((name) => {
      if (temp.includes(name)) {
        obj = {
          ...obj,
          [AllTabs[name].priority]: AllTabs[name].name,
        };
      }
    });
    return obj;
  }
  useEffect(() => {
    setTabsControl(tabsPrevNextControl());
  }, [tabs]);
  function handleNextFormButton() {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a + 1];
    setActiveTabName(tabsControl[b]);
    console.log("absControl[b]", tabsControl[b]);
    setActiveStep1(b - 1);
  }
  const removeIdsForNewlyCreated = (data) => {
    const newStocks =
      data &&
      data.stocks &&
      data.stocks.map((stock) => {
        if (stock.created && stock.created === "newly") {
          const { id, ...rest } = stock;
          return rest;
        }
        return stock;
      });

    const newDetails =
      data &&
      data.details &&
      data.details.map((detail) => {
        if (detail.created && detail.created === "newly") {
          const { id, ...rest } = detail;
          return rest;
        }
        return detail;
      });
    return {
      Stock: newStocks,
      Details: newDetails,
    };
  };
  // console.log("stocksToCreate",stocksToCreate,removeIdsForNewlyCreated(stocksToCreate))
  const ModuleStocksCreate = async (data, moduleCreatedId) => {
    try {
      setIsLoading(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const queryParam =
        userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
      const response = await axios.post(
        `${baseUrl}/stocks/create${queryParam}`,
        { data, cmId: moduleCreatedId },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response);
      // if (response && response.data && response.data.status === 200) {
      //   // await getStocksDetails();
      //   swal("Success", response.data.message, "success");
      // }
      // if (response && response.data && response.data.status === 400) {
      //   swal("Error", response.data.message, "error");
      // }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
  };
  async function handleSubmit() {
    setIsLoading(true);
    console.log("moduleName", submitBody);
    if (moduleName && moduleId === null) {
      console.log("create api");
      try {
        if (moduleName && moduleId === null) {
          const clientModule = {
            ...submitBody,
            ["Value as of Date"]: submitBody["Value as of Date"]
              ? submitBody["Value as of Date"]
              : new Date(),
            asset_status: "unSold",
            ["This Asset is Liquid"]: submitBody["This Asset is Liquid"]
              ? submitBody["This Asset is Liquid"]
              : false,
          };
          if (userRole && userRole === "Financial Advisor Client") {
            clientModule["Share with Financial Adviser"] = true;
          }
          if (module === "Investment Portfolio") {
            let allStocksData = removeIdsForNewlyCreated(stocksToCreate);
            const cashValue = clientModule["Cash Holding"] || 0;
            const marketValueBuy =
              allStocksData &&
              allStocksData.Stock &&
              allStocksData.Stock.reduce(
                (sum, item) => sum + +item.approximateMarketValue,
                0
              );
            console.log("alllstcoks", allStocksData, stocksToCreate);
            const marketValueNewBuy =
              allStocksData &&
              allStocksData.Stock &&
              allStocksData.Stock.reduce((sum, item) => {
                return item.created === "newly"
                  ? sum + Number(item.approximateMarketValue)
                  : sum;
              }, 0);
            clientModule["Stock Value"] = marketValueNewBuy;
            if (fieldsData.managedBy === "Plaid") {
              clientModule["Stock Value"] = marketValueBuy;
              clientModule["Monetary Value"] = marketValueBuy + cashValue;
            } else {
              clientModule["Monetary Value"] = marketValueBuy + cashValue;
            }
          }

          const moduleNew = await MODULE_API.addAsset(moduleName, {
            clientModules: [clientModule],
          });
          if (moduleNew && moduleNew.status === 400) {
            if (moduleNew.message) {
              swal({
                title: "Error",
                text: moduleNew.message,
                icon: "error",
                buttons: true,
                dangerMode: true,
              });
            }
            setIsLoading(false);
            return;
          }
          if (module === "Investment Portfolio" && stocksToCreate) {
            console.log("moduleNew", moduleNew);
            let allStocksData = removeIdsForNewlyCreated(stocksToCreate);
            let moduleCreatedId =
              moduleNew &&
              moduleNew.clientModules[0] &&
              moduleNew.clientModules[0].id;
            await ModuleStocksCreate(allStocksData, moduleCreatedId);
          }
          setIsLoading(false);
          history.push("/assets");
        }
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
    if (moduleId && moduleName) {
      console.log("updateApi");
      try {
        if (module === "Investment Portfolio") {
          let allStocksData = removeIdsForNewlyCreated(stocksToCreate);
          const cashValue =
            +submitBody["Cash Holding"] || +fieldsData["Cash Holding"] || 0;
          const monetaryValue =
            +submitBody["Monetary Value"] || +fieldsData["Monetary Value"] || 0;

          const marketValueNewBuy =
            allStocksData &&
            allStocksData.Stock &&
            allStocksData.Stock.reduce((sum, item) => {
              return item.created === "newly"
                ? sum + Number(item.approximateMarketValue)
                : sum;
            }, 0);
          const marketValueBuy =
            allStocksData &&
            allStocksData.Stock &&
            allStocksData.Stock.reduce(
              (sum, item) => sum + +item.approximateMarketValue,
              0
            );
          const stockValue =
            +submitBody["Stock Value"] || +fieldsData["Stock Value"] || 0;
          console.log(
            "stockestststs",
            stockValue,
            cashValue,
            marketValueBuy,
            marketValueNewBuy
          );
          if (fieldsData.managedBy === "Plaid") {
            submitBody["Stock Value"] = marketValueBuy;
            submitBody["Monetary Value"] = marketValueBuy + cashValue;
          } else {
            submitBody["Stock Value"] = marketValueBuy;
            submitBody["Monetary Value"] = marketValueBuy + cashValue;
          }
        }
        await MODULE_API.updateClientModule(moduleId, {
          ...submitBody,
        });
        if (module === "Investment Portfolio" && stocksToCreate) {
          let allStocksData = removeIdsForNewlyCreated(stocksToCreate);
          await ModuleStocksCreate(allStocksData, moduleId);
        }
        setIsLoading(false);
        history.push("/assets");
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
  }

  function currentTab(tab) {
    tabs2 = tabs.map((tab) => tab.toUpperCase());

    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  }

  useEffect(() => {
    console.log("Object.keys(fields", Object.keys(fields));
    const sortedArray = Object.keys(fields).sort(
      (a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b)
    );

    setTabs(sortedArray);
    console.log("askaksnclaksnc", tabs);
  }, [fields]);

  useEffect(() => {
    currentTab(activeTabName);
    console.log("currentTab(activeTabName)", tabs);
  }, [tabs]);

  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    console.log("tabs2asa", tabs2);
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);

  //   --------------LOG useEffects-------------------
  useEffect(() => {
    console.log("fields", fields);
  }, [fields]);
  useEffect(() => {
    if (module) {
      getAssetFields(module);
      setModuleName(module || null);
    }
    if (id) {
      getAssetFieldsData(id);
      setModuleId(id || null);
    }
  }, [module, id]);

  return (
    <>
      {/* <AssetLissting/> */}
      <hr />
      <TabNavigationComponent
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        activeStep1={activeStep1}
        currentTab={currentTab}
        AllTabs={AllTabs}
      />
      <hr />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1rem",
        }}
      >
        {loadingFields ? <Spin size="large" /> : null}
      </div>
      <form>
        {tabs.length > 0 && (
          <FormCreator
            data={fields[tabs[activeTabIndex]]}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            stocksToCreate={setStocksToCreate}
            setOriginalStocks={setOriginalStocks}
            activeTabName={activeTabName}
          />
        )}
      </form>
      {tabs.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3rem 3rem",
            width: "96%",
          }}
        >
          <Button
            onClick={() => {
              if (activeTabName == "ASSET INFORMATION") {
                history.goBack();
              } else {
                handlePreviousFormButton();
              }
            }}
            style={{
              backgroundColor: "transparent",
              color: "#2a3da3",
              borderRadius: "8px",
              border: "1px solid #2a3da3",
              width: "250px",
              height: "3rem",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Poppins",
            }}
            // disabled={activeTabName == "ASSET INFORMATION"}
          >
            Previous
          </Button>
          {activeTabName !== "TAX AND LIQUIDITY" ? (
            <Button
              onClick={handleNextFormButton}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Next
            </Button>
          ) : (
            <Button
              onClick={() => {
                handleSubmit();
              }}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Submit
            </Button>
          )}
        </div>
      )}

      <NewLoader isLoading={loading} />
    </>
  );
};

const FormCreator = ({
  data,
  title,
  setSubmitBody,
  activeTabName,
  values,
  stocksToCreate,
  setOriginalStocks,
}) => {
  const { Panel } = Collapse;
  // ------------------HOOKS--------------
  const [inputFields, setInputFields] = useState([]);
  const [groupedFields, setGroupedFields] = useState({});
  const [payload, setPayload] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  console.log("attribute data ==> ", data);

  const orderOfNames = [
    "Value Based on Rate of Return",
    "Actual Value at Sale Date",
    "Date of Sale",
    "Total Liabilities",
    "Commission on Sale",
    "Taxes",
    "Other Transaction Costs",
  ];
  const sortedDataNames = Object.values(data).sort((a, b) => {
    return orderOfNames.indexOf(a.name) - orderOfNames.indexOf(b.name);
  });
  const dataObject = {};
  for (const item of sortedDataNames) {
    dataObject[item.name] = item;
  }
  console.log("dataObject111", dataObject);

  const orderOfNamesInfo = [
    "Name of Asset",
    "Owner",
    "Account Type/Titled",
    "Account Number",
    "This Asset produces Income",
    "This Asset has a Loan",
    "Loan End Date",
    "Loan Interest Rate",
    "Share with Financial Adviser",
    "incomeModule",
    "Upload Document",
    "File Name",
  ];

  const sortedDataNamesInfo = Object.values(data).sort((a, b) => {
    return orderOfNamesInfo.indexOf(a.name) - orderOfNamesInfo.indexOf(b.name);
  });

  const dataObjectInfo = {};
  for (const item of sortedDataNamesInfo) {
    dataObjectInfo[item.name] = item;
  }
  console.log("dataObjectInfo", dataObjectInfo);

  const orderOfNamesTax = [
    "Cost Basis",
    "Cost Basis Date",
    "Estimated Unrealized Gain/Loss",
    "Taxability while Owned",
    "This Asset is Liquid",
    "Taxability on Distribution",
    "Early Withdrawl Penalty",
    "Taxability Of Distribution",
    "Penalty Based on Age",
  ];

  const sortedDataNamesTax = Object.values(data).sort((a, b) => {
    return orderOfNamesTax.indexOf(a.name) - orderOfNamesTax.indexOf(b.name);
  });

  const dataObjectTax = {};
  for (const item of sortedDataNamesTax) {
    dataObjectTax[item.name] = item;
  }
  console.log("dataObjectTax", dataObjectTax);
  const orderOfNamesPerformance = [
    "Cost Basis",
    "Cost Basis Date",
    "Rate Of Return (if applicable)",
    "Static",
    "User Defined",
    "Monetary Value",
    "Value as of Date",
    "Estimated Unrealized Gain/Loss",
  ];
  const sortedDataNamesPerformance = Object.values(data).sort((a, b) => {
    return (
      orderOfNamesPerformance.indexOf(a.name) -
      orderOfNamesPerformance.indexOf(b.name)
    );
  });
  const dataObjectPerformance = {};
  for (const item of sortedDataNamesPerformance) {
    dataObjectPerformance[item.name] = item;
  }
  console.log("dataObjectPerformance", dataObjectPerformance);
  useEffect(() => {
    console.log("Object.keys(data)", Object.keys(data), activeTabName);
    setInputFields(Object.keys(data));
  }, [data]);
  useEffect(() => {
    setSubmitBody(payload);
  }, [payload]);
  useEffect(() => {
    setAttributeValues(values);
  }, [values]);

  const [ContributionOrDistribution, AddContributionOrDistribution] = useState(
    {}
  );
  const [assetBeneficiaryAssignment, setAssetBeneficiaryAssignment] = useState(
    {}
  );
  const [advancedInformation, setAdvancedInformation] = useState({});
  const [liveStock, setLiveStock] = useState({});
  const [stockMarket, setStockMarket] = useState({});
  const [investmentProperty, setInvestmentProperty] = useState({});
  const [tooltipModal, setTooltipModal] = useState(false);
  const [stockData, setStockData] = useState(null);
  const [stockCount, setStockCount] = useState(1);
  const [stockList, setStockList] = useState([]);
  const [stockGain, setStockGain] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [formDataOwner, setFormDataOwner] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDefined, setUserDefined] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const handleChangeOwner = (name, value) => {
    setFormDataOwner({
      ...formDataOwner,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormDataOwner(null);
  };

  const handleSave = async () => {
    setIsModalOpen(false);
    try {
      let payload = {
        ...formDataOwner,
      };

      setLoading(true);
      let data = await MODULE_API.addAsset("Owners and Entities", {
        clientModules: [{ ...payload }],
      });
      if (data && data.statusCode === 201) {
        swal("Success", "Owner Details Added Successfully.", "success");
        await getOwnersDetails(1);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormDataOwner(null);
  };

  const getUserDefined = async (page) => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.getUserDefined(page);
      if (data && data.data) {
        const { rows, count } = data.data;
        setUserDefined((prevState) => [...prevState, ...rows]);
        const totalPages = Math.ceil(count / 10);
        setHasMore(page < totalPages);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const handlePopupScroll = (e) => {
    const { target } = e;
    if (
      !loading &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      getUserDefined(nextPage);
    }
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  useEffect(() => {
    console.log("inputFields 111", inputFields, activeTabName);
    const orderOfNames = [
      "Value Based on Rate of Return",
      "Actual Value at Sale Date",
      "Date of Sale",
      "Total Liabilities",
      "Commission on Sale",
      "Taxes",
      "Other Transaction Costs",
    ];
    const orderOfNamesInfo = [
      "This Asset produces Income",
      "Owner",
      "This Asset has a Loan",
      "Account Number",
      "Account Type/Titled",
      "Name of Asset",
    ];

    if (activeTabName === "SELLING ASSET COSTS") {
      orderOfNames.map((item) => {
        console.log(
          "orderOfNamesorderOfNamesorderOfNames",
          item,
          dataObject[item]
        );
        if (dataObject[item] && dataObject[item]["groupName"]) {
          console.log("new daataaaaa", dataObject[item]["groupName"]);
          setGroupedFields((prevValue) => {
            console.log("new daataaaaa prevValue", prevValue);
            return {
              ...prevValue,
              [dataObject[item].groupName]: {
                ...prevValue[dataObject[item].groupName],
                [dataObject[item].id]: dataObject[item],
              },
            };
          });
        }
      });
    } else {
      inputFields.map((item) => {
        if (data[item] && data[item]["formGroupName"]) {
          setGroupedFields((prevValue) => {
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        }
        if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Add Contribution or Distribution"
        ) {
          AddContributionOrDistribution((prevValue) => {
            console.log("else if data", prevValue);

            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        } else if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Individual Stocks"
        ) {
          setStockMarket((prevValue) => {
            console.log("else if data", prevValue);
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        } else if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Investment Property Expenses"
        ) {
          setInvestmentProperty((prevValue) => {
            console.log("else if data", prevValue);
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        } else if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Asset Beneficiary Assignment"
        ) {
          setAssetBeneficiaryAssignment((prevValue) => {
            console.log("else if data", prevValue);
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        } else if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Advanced Information"
        ) {
          setAdvancedInformation((prevValue) => {
            console.log("else if data", prevValue);
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        }
        if (
          data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Live Stock"
        ) {
          setLiveStock((prevValue) => {
            console.log("else if data", prevValue);
            return {
              ...prevValue,
              [data[item].formGroupName]: {
                ...prevValue[data[item].formGroupName],
                [data[item].id]: data[item],
              },
            };
          });
        } else {
          return null;
        }
      });
    }
    console.log("groupedFields", groupedFields);
  }, [data, inputFields]);
  // function handleInputFields(inputName, value) {
  //   setPayload((prevValue) => {
  //     return { ...prevValue, [inputName]: value };
  //   });
  // }

  useEffect(() => {
    if (payload["Monetary Value"] || payload["Cost Basis"]) {
      calculateDifference();
    }
  }, [payload["Monetary Value"], payload["Cost Basis"]]);

  // useEffect(() => {
  //   if (payload["Static"] && payload["Cost Basis"]) {
  //     calculateMonetoryValue();
  //   }
  // }, [payload["Static"], payload["Cost Basis"]]);

  useEffect(() => {
    if (
      payload["Enter Portfolio % of Bonds"] ||
      payload["Enter Portfolio % of S&P 500"] ||
      payload["Enter Portfolio % of Cash"] ||
      payload["Enter Portfolio % of Real Estate"] ||
      payload["Enter Portfolio % of Gold"]
    ) {
      calculateTotalPercentage();
    }
  }, [
    payload["Enter Portfolio % of S&P 500"],
    payload["Enter Portfolio % of Bonds"],
    payload["Enter Portfolio % of Cash"],
    payload["Enter Portfolio % of Real Estate"],
    payload["Enter Portfolio % of Gold"],
  ]);

  function calculateMonetoryValue() {
    const currentDate = new Date();
    let Start =
      (payload["Cost Basis Date"] && new Date(payload["Cost Basis Date"])) ||
      (attributeValues["Cost Basis Date"] &&
        new Date(attributeValues["Cost Basis Date"])) ||
      new Date();
    const differenceInMs = currentDate.getTime() - Start.getTime();
    const daysDifference = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    let totalDays = daysDifference / 365;
    console.log("Number of days difference:", daysDifference, totalDays);
    // new formula for montary value
    let Cost = payload["Cost Basis"] || attributeValues["Cost Basis"] || 0;
    let ReturnRate = payload["Static"] || attributeValues["Static"] || 0;
    let decimalValue = ReturnRate ? ReturnRate / 100 : 0;
    const amount = 1 + decimalValue / 365;
    let power = Math.pow(amount, totalDays * 365);
    const estimateDiff = Cost * power;

    // const estimateDiff =
    //  (parseFloat(Cost) * (1+(decimalValue / totalDays))) ^ totaldays*365;

    console.log("estimateDiff", estimateDiff);
    if (estimateDiff > 0 && !isNaN(estimateDiff)) {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Monetary Value"]: estimateDiff.toFixed(2),
          ["Value as of Date"]: new Date(),
        };
      });
      setAttributeValues((prevValue) => {
        return {
          ...prevValue,
          ["Monetary Value"]: estimateDiff.toFixed(2),
          ["Value as of Date"]: new Date(),
        };
      });
    } else {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Monetary Value"]: 0,
          ["Value as of Date"]: new Date(),
        };
      });
    }
  }
  console.log("payload222", payload);
  function calculateDifference() {
    let Cost = payload["Cost Basis"] || attributeValues["Cost Basis"] || 0;
    let Monetary =
      payload["Monetary Value"] || attributeValues["Monetary Value"] || 0;

    const estimateDiff = Monetary - Cost;

    console.log("Years difference:", estimateDiff.toFixed(2));
    if (!isNaN(estimateDiff)) {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Estimated Unrealized Gain/Loss"]: estimateDiff.toFixed(2),
        };
      });
    } else {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Estimated Unrealized Gain/Loss"]: 0,
        };
      });
    }
  }

  function calculateTotalPercentage() {
    let Bonds =
      parseFloat(payload["Enter Portfolio % of Bonds"]) ||
      parseFloat(attributeValues["Enter Portfolio % of Bonds"]) ||
      0;
    let Sp =
      parseFloat(payload["Enter Portfolio % of S&P 500"]) ||
      parseFloat(attributeValues["Enter Portfolio % of S&P 500"]) ||
      0;
    let Cash =
      parseFloat(payload["Enter Portfolio % of Cash"]) ||
      parseFloat(attributeValues["Enter Portfolio % of Cash"]) ||
      0;
    let RealEstate =
      parseFloat(payload["Enter Portfolio % of Real Estate"]) ||
      parseFloat(attributeValues["Enter Portfolio % of Real Estate"]) ||
      0;
    let Gold =
      parseFloat(payload["Enter Portfolio % of Gold"]) ||
      parseFloat(attributeValues["Enter Portfolio % of Gold"]) ||
      0;
    let estimatePercentage = 0;
    estimatePercentage = Sp + RealEstate + Bonds + Cash + Gold;

    if (estimatePercentage > 100) {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Total Percentage"]: "error",
        };
      });
    } else {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Total Percentage"]: estimatePercentage,
        };
      });
    }
  }

  // for stock market start code
  const [expandedTableData, setExpandedTableData] = useState([]);
  const [stockBuyData, setStockBuyData] = useState({});
  const [expandedRow, setExpandedRow] = useState(null);
  const [stockUpdate, setStockUpdate] = useState(false);
  const [editCashHoldindg, setEditCashHoldindg] = useState(false);
  const [loadingStocks, setLoadingStocks] = useState(false);
  const [stockToSave, setStockToSave] = useState([]);
  const [stockToDetailsSave, setStockDetailsToSave] = useState([]);

  const getExpandedRow = (record) => {
    console.log("record data22", record);
    setExpandedRow(record);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setEditCashHoldindg(false);
    }
  };
  const calculateRealizedGain = (record) => {
    const {
      buySell,
      pricePerShare,
      shares,
      commission,
      commissionType,
      parentShares,
    } = record;
    const totalValue = pricePerShare * shares;
    const totalCommission =
      commissionType === "Flat Fee"
        ? commission
        : (commission / 100) * totalValue;
    // console.log("purchaseRecord record",record)
    if (buySell === "Sell") {
      const originalBuyPrice = getOriginalBuyPrice(record);
      const gain = totalValue - originalBuyPrice * shares - totalCommission;
      return gain
        ? `$${gain
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        : "N/A";
      // return gain.toFixed(2);
    }

    return "N/A";
  };

  const getOriginalBuyPrice = (record) => {
    const { tickerSymbol, parentShares } = record;
    // Find the earliest purchase record for the given stock symbol
    const purchaseRecord =
      stockList && stockList.find((pr) => pr.tickerSymbol === tickerSymbol);
    // console.log("purchaseRecord",purchaseRecord,parentShares,tickerSymbol,record)
    // Return the price per share of the earliest purchase
    return purchaseRecord ? purchaseRecord.pricePerShare : 0;
  };
  useEffect(() => {
    let obj = {
      stocks: stockList,
      details: expandedTableData,
    };
    stocksToCreate(obj);
  }, [stockToSave, stockToDetailsSave, stockList]);
  useEffect(() => {
    if (stockList && stockList.length > 0) {
      let totalGainLoss = 0;
      let cashHolding = 0;
      let dayGain = 0;
      let currentPrice = 0;
      let closePrice = 0;
      let closeBasis = 0;
      let totalGainLossCalculate = 0;
      stockList &&
        stockList.forEach((stock) => {
          if (stock) {
            if (stock.tickerSymbol === "CUR:USD") {
              cashHolding += parseFloat(stock.approximateMarketValue || 0);
            }
            currentPrice += parseFloat(stock.pricePerShare || 0);
            closePrice += parseFloat(
              stock.closePrice || stock.pricePerShare || 0
            );
            if (stock.tickerSymbol !== "CUR:USD") {
              closeBasis += parseFloat(stock.approximateMarketValue || 0);
            }
            const gainLossDay =
              parseFloat(stock.pricePerShare || 0) -
              parseFloat(stock.closePrice || stock.pricePerShare || 0);
            const gainLossTotal =
              parseFloat(stock.pricePerShare || 0) -
              parseFloat(
                stock.averageCost || stock.approximateMarketValue || 0
              );
            totalGainLoss += gainLossTotal;
            dayGain += gainLossDay;

            if (stock.updatedAt) {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            } else {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue) /
                      parseFloat(stock.shares)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            }
          }
        });
      console.log(
        "totalGainLoss",
        totalGainLoss,
        closeBasis,
        stockList,
        totalGainLossCalculate
      );
      const gainLossDayPercentage = closePrice
        ? ((currentPrice - closePrice) / closePrice) * 100
        : 0;
      const gainLossTotalPercentage = closeBasis
        ? ((currentPrice - closeBasis) / closeBasis) * 100
        : 0;
      const totalPercentageGainorLossvalue = totalGainLossCalculate;
      const totalPercentageGainorLoss =
        (totalGainLossCalculate / closeBasis) * 100;
      const resultObject = {
        totalGainLoss,
        cashHolding,
        dayGain,
        gainLossDayPercentage,
        gainLossTotalPercentage,
        closeBasis,
        totalPercentageGainorLossvalue,
        totalPercentageGainorLoss,
      };
      setStockGain(resultObject);
    } else {
      setStockGain([]);
    }
  }, [stockList]);

  function NestedTable({ StockData, expandedData }) {
    const [addRow, setAddRow] = useState(false);

    const [editingKey, setEditingKey] = useState("");
    const [editingRow, setEditingRow] = useState({});
    const isEditing = (record) => record.id === editingKey;
    const edit = (record) => {
      setEditingKey(record.id);
      setEditingRow({ ...record });
    };
    const handleInputChange = (value, fieldName) => {
      setEditingRow((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    };
    const handleSaveDetails = async (e) => {
      e.preventDefault();
      let row = {
        ...editingRow,
        name: editingRow.name ? editingRow.name : editingRow.tickerSymbol,
      };
      if (row) {
        setStockList((prevStockList) =>
          prevStockList.map((stock) =>
            stock.id === row.id ? { ...stock, ...row } : stock
          )
        );
        setStockToSave((prevStockList) => {
          const existingRow = prevStockList.find(
            (stock) => stock.id === row.id
          );
          if (existingRow) {
            // Update existing row
            return prevStockList.map((stock) =>
              stock.id === row.id ? { ...stock, ...row } : stock
            );
          } else {
            // Add new row
            return [...prevStockList, row];
          }
        });
        // try {
        //   setLoading(true);
        //   const userToken = localStorage.getItem("userLoginToken");
        //   const baseUrl = "https://sam.assetplanet.com/plaid-service";
        //   const response = await axios.put(
        //     `${baseUrl}/stocks/manual?id=${editingRow.id}`,
        //     editingRow,
        //     {
        //       headers: {
        //         Authorization: `Bearer ${userToken}`,
        //       },
        //     }
        //   );
        //   console.log("response", response);
        //   if (response && response.data && response.data.status === 200) {
        //     swal("Success", response.data.message, "success");
        //   }
        //   await getStocks();
        //   setLoading(false);
        // } catch (error) {
        //   setLoading(false);
        //   if (error && error.data && error.data.message) {
        //     swal("Success", error.data.message, "success");
        //   }
        //   console.error("Error fetching user data:", error);
        // }
      }
      setEditingKey("");
    };
    const calculateShares = (data) => {
      const buys = data.filter(
        (item) => item.buySell && item.buySell === "Buy"
      );
      const sells = data.filter(
        (item) => item.buySell && item.buySell === "Sell"
      );

      const totalBuys = buys.reduce((sum, item) => sum + +item.shares, 0);
      const totalSells = sells.reduce((sum, item) => sum + +item.shares, 0);

      return totalBuys - totalSells;
    };
    const calculateAverageCost = (data) => {
      const buys = data.filter(
        (item) => item.buySell && item.buySell === "Buy"
      );
      const sells = data.filter(
        (item) => item.buySell && item.buySell === "Sell"
      );
      // Calculate total cost and total shares for buys and sells
      const totalBuys =
        buys && buys.reduce((sum, item) => sum + +item.shares, 0);
      const totalSells =
        sells && sells.reduce((sum, item) => sum + +item.shares, 0);

      const totalBuyCost =
        buys &&
        buys.reduce((sum, item) => sum + +item.shares * +item.pricePerShare, 0);
      const totalSellCost =
        sells &&
        sells.reduce(
          (sum, item) => sum + +item.shares * +item.pricePerShare,
          0
        );
      // Calculate overall total cost and total shares
      const overallTotalCost = totalBuyCost + totalSellCost;
      const overallTotalShares = totalBuys + totalSells;
      const totalAverageCost =
        overallTotalShares > 0 ? overallTotalCost / overallTotalShares : 0;
      // Calculate average cost for buys and sells
      const averageBuyCost = totalBuys > 0 ? totalBuyCost / totalBuys : 0;
      const averageSellCost = totalSells > 0 ? totalSellCost / totalSells : 0;
      const marketValueBuy =
        buys &&
        buys.reduce((sum, item) => sum + +item.approximateMarketValue, 0);
      const marketValueSell =
        buys &&
        buys.reduce((sum, item) => sum + +item.approximateMarketValue, 0);
      const totalMarketValue = marketValueBuy;
      console.log(
        "overallTotalCost",
        overallTotalCost,
        totalMarketValue,
        marketValueBuy,
        marketValueSell
      );
      return { totalMarketValue, totalAverageCost, overallTotalCost };
    };
    const handleExpandRowSave = async (data) => {
      let jsonObj = {
        ...data,
        id: expandedTableData.length,
      };
      let nestedData =
        expandedTableData &&
        expandedTableData.filter(
          (item) => item.tickerSymbol === data.tickerSymbol
        );
      nestedData = nestedData.concat(jsonObj);
      let stockToUpdate =
        stockList &&
        stockList.find((item) => item.tickerSymbol === data.tickerSymbol);
      if (stockToUpdate) {
        let formula = nestedData && calculateAverageCost(nestedData);
        stockToUpdate.shares = nestedData && calculateShares(nestedData);
        stockToUpdate.averageCost = formula && formula.totalAverageCost;
        stockToUpdate.approximateMarketValue =
          formula && formula.totalMarketValue;
        stockToUpdate.totalCost = formula && formula.overallTotalCost;
        setStockList((prevStockList) =>
          prevStockList.map((stock) =>
            stock.id === stockToUpdate.id
              ? { ...stock, ...stockToUpdate }
              : stock
          )
        );
        setStockToSave((prevStockList) => {
          const existingRow = prevStockList.find(
            (stock) => stock.id === stockToUpdate.id
          );
          if (existingRow) {
            // Update existing row
            return prevStockList.map((stock) =>
              stock.id === stockToUpdate.id
                ? { ...stock, ...stockToUpdate }
                : stock
            );
          } else {
            // Add new row
            return [...prevStockList, stockToUpdate];
          }
        });
      }

      // console.log("jsonObjNew",stockToUpdate,stockList,jsonObj,nestedData,expandedTableData)
      setExpandedTableData((prevDetailList) => [...prevDetailList, jsonObj]);
      setStockDetailsToSave((prevDetailList) => [...prevDetailList, jsonObj]);
    };
    console.log("stock to save", stockToSave, stockToDetailsSave);
    const calculateMarketValue = (
      noOfShares,
      pricePerShare,
      commission,
      commissionType
    ) => {
      const shares = noOfShares ? +noOfShares : 0;
      const price = pricePerShare ? +pricePerShare : 0;
      let commissions = 0;
      if (commissionType && commissionType === "Flat Fee") {
        commissions = commission ? +commission : 0;
      } else {
        const priceTotal = shares * price;
        commissions = commission ? (+commission / 100) * priceTotal : 0;
      }
      return shares * price - commissions;
    };
    const handleExpandRowUpdate = async (rowData) => {
      let marketValue = calculateMarketValue(
        rowData.shares,
        rowData.pricePerShare,
        rowData.commission,
        rowData.commissionType
      );
      console.log("rowData", rowData, marketValue);
      if (rowData) {
        let rowDataToSave = {
          ...rowData,
          approximateMarketValue: marketValue,
        };
        let nestedData =
          expandedTableData &&
          expandedTableData.filter(
            (item) => item.tickerSymbol === rowDataToSave.tickerSymbol
          );
        let updatedNestedData =
          nestedData &&
          nestedData.map((item) => {
            if (item.id === rowDataToSave.id) {
              // Return the updated object where ids match
              return {
                ...item,
                ...rowDataToSave,
              };
            }
            // Return the original object if no match
            return item;
          });
        console.log("updatedExpandedTableData", updatedNestedData);
        // nestedData = nestedData.concat(rowDataToSave);
        let stockToUpdate =
          stockList &&
          stockList.find(
            (item) => item.tickerSymbol === rowDataToSave.tickerSymbol
          );
        if (stockToUpdate) {
          let formula =
            updatedNestedData && calculateAverageCost(updatedNestedData);
          stockToUpdate.shares =
            updatedNestedData && calculateShares(updatedNestedData);
          stockToUpdate.averageCost = formula && formula.totalAverageCost;
          stockToUpdate.approximateMarketValue =
            formula && formula.totalMarketValue;
          stockToUpdate.totalCost = formula && formula.overallTotalCost;
          setStockList((prevStockList) =>
            prevStockList.map((stock) =>
              stock.id === stockToUpdate.id
                ? { ...stock, ...stockToUpdate }
                : stock
            )
          );
          setStockToSave((prevStockList) => {
            const existingRow = prevStockList.find(
              (stock) => stock.id === stockToUpdate.id
            );
            if (existingRow) {
              // Update existing row
              return prevStockList.map((stock) =>
                stock.id === stockToUpdate.id
                  ? { ...stock, ...stockToUpdate }
                  : stock
              );
            } else {
              // Add new row
              return [...prevStockList, stockToUpdate];
            }
          });
        }
        setExpandedTableData((prevDetailList) => {
          const existingRow = prevDetailList.find(
            (stock) => stock.id === rowDataToSave.id
          );
          // console.log("existingRow",prevDetailList,stockToDetailsSave,existingRow,rowDataToSave)
          if (existingRow) {
            // Update existing row
            return prevDetailList.map((stock) =>
              stock.id === rowDataToSave.id
                ? { ...stock, ...rowDataToSave }
                : stock
            );
          } else {
            // Add new row
            return [...prevDetailList, rowDataToSave];
          }
        });
        setStockDetailsToSave((prevStockList) => {
          const existingRow = prevStockList.find(
            (stock) => stock.id === rowDataToSave.id
          );
          // console.log("existingRow",prevStockList,stockToDetailsSave,existingRow,rowDataToSave)
          if (existingRow) {
            // Update existing row
            return prevStockList.map((stock) =>
              stock.id === rowDataToSave.id
                ? { ...stock, ...rowDataToSave }
                : stock
            );
          } else {
            // Add new row
            return [...prevStockList, rowDataToSave];
          }
        });
      }
    };
    const cancel = () => {
      setEditingKey("");
    };
    const columns = [
      {
        title: "Symbol",
        dataIndex: "tickerSymbol",
        sorter: (a, b) =>
          (a.tickerSymbol || "").localeCompare(b.tickerSymbol || ""),
        render: (text, record) =>
          isEditing(record) ? (
            <input
              className="roleInput"
              style={{ marginBottom: "0px" }}
              placeholder="Symbol"
              name="tickerSymbol"
              // value={editingRow && editingRow.tickerSymbol}
              value={
                editingRow &&
                editingRow.tickerSymbol &&
                editingRow.tickerSymbol.toUpperCase()
              }
              id="tickerSymbol"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.value, "tickerSymbol");
              }}
            />
          ) : (
            (text && text.toUpperCase()) || "N/A"
          ),
        // render: (fileName, record) => {
        //   return record.tickerSymbol && record.tickerSymbol ? (
        //     <div style={{ textAlign: "center" }}>
        //       <div style={{ color: "#2a3da3", fontWeight: "bold" }}>
        //         {record.tickerSymbol}
        //       </div>
        //     </div>
        //   ) : (
        //     "N/A"
        //   );
        // },
      },
      {
        title: "Day Change",
        dataIndex: "dayChange",
        sorter: (a, b) => {
          const amountA = parseFloat(a.dayChange);
          const amountB = parseFloat(b.dayChange);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Day Change"
                name="dayChange"
                value={editingRow && editingRow.dayChange}
                onChange={(value) => {
                  handleInputChange(value, "dayChange");
                }}
              />
            </div>
          ) : text ? (
            <div
              style={{
                color: record.dayChange > 0 ? "#4cbb17" : "red",
                fontWeight: "bold",
              }}
            >
              {`$${parseFloat(text)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
            </div>
          ) : (
            "N/A"
          ),
        // render: (fileName, record) => {
        //   return record.dayChange && record.dayChange ? (
        //     <div>
        //       <div
        //         style={{
        //           color: record.dayChange > 0 ? "#4cbb17" : "red",
        //           fontWeight: "bold",
        //         }}
        //       >
        //         {record.dayChange
        //           ? `$${parseFloat(record.dayChange)
        //               .toFixed(2)
        //               .toString()
        //               .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
        //           : "0"}

        //       </div>
        //     </div>
        //   ) : (
        //     "N/A"
        //   );
        // },
      },
      {
        title: "Shares",
        dataIndex: "shares",
        sorter: (a, b) => {
          const amountA = parseFloat(a.shares);
          const amountB = parseFloat(b.shares);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <input
              className="roleInput"
              style={{ marginBottom: "0px" }}
              placeholder="Shares"
              name="shares"
              value={editingRow && editingRow.shares}
              id="shares"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.value, "shares");
              }}
            />
          ) : text ? (
            <span style={{ color: "black", fontWeight: "bold" }}>
              {record.shares}
            </span>
          ) : (
            "N/A"
          ),
        // render: (fileName, record) => {
        //   return record.shares ? (
        //     <div>
        //       {record.shares && (
        //         <span style={{ color: "black", fontWeight: "bold" }}>
        //           {record.shares}
        //         </span>
        //       )}
        //     </div>
        //   ) : (
        //     "N/A"
        //   );
        // },
      },
      {
        title: "Average Cost",
        dataIndex: "averageCost",
        sorter: (a, b) => {
          const amountA = parseFloat(a.averageCost);
          const amountB = parseFloat(b.averageCost);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span className="dollarSymbol">$</span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Average Cost"
                name="averageCost"
                value={editingRow && editingRow.averageCost}
                id="averageCost"
                onChange={(value) => {
                  handleInputChange(value, "averageCost");
                }}
              />
            </div>
          ) : record.shares ? (
            `$${(
              parseFloat(Number(record.totalCost) || Number(record.averageCost)) /
              parseFloat(Number(record.shares))
            )
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : text ? (
            `$${parseFloat(Number(text))
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : (
            "N/A"
          ),
        // render: (record) => (record ? `$${parseFloat(record)
        //         .toFixed(2)
        //         .toString()
        //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "N/A"),
      },
      {
        title: "Total Cost",
        dataIndex: "totalCost",
        sorter: (a, b) => {
          const amountA = parseFloat(a.totalCost);
          const amountB = parseFloat(b.totalCost);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span className="dollarSymbol">$</span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Total Cost"
                name="totalCost"
                value={editingRow && editingRow.totalCost}
                id="totalCost"
                onChange={(value) => {
                  handleInputChange(value, "totalCost");
                }}
              />
            </div>
          ) : text ? (
            `$${parseFloat(text)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : record.averageCost !== null &&
            record.averageCost !== undefined ? (
            `$${parseFloat(record.averageCost)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : (
            "N/A"
          ),
        // render: (record) => (record ? `$${parseFloat(record)
        //         .toFixed(2)
        //         .toString()
        //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "N/A"),
      },
      {
        title: "Market Value",
        dataIndex: "approximateMarketValue",
        sorter: (a, b) => {
          const amountA = parseFloat(a.approximateMarketValue);
          const amountB = parseFloat(b.approximateMarketValue);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span className="dollarSymbol">$</span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Approximate Market Value"
                name="approximateMarketValue"
                value={editingRow && editingRow.approximateMarketValue}
                id="approximateMarketValue"
                onChange={(value) => {
                  handleInputChange(value, "approximateMarketValue");
                }}
              />
            </div>
          ) : text ? (
            `$${parseFloat(text)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : (
            "N/A"
          ),
        // render: (record) => (record && record!==undefined ? `$${parseFloat(record)
        //         .toFixed(2)
        //         .toString()
        //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "N/A"),
      },
      {
        title: "Type",
        dataIndex: "dividentIncome",
        sorter: (a, b) =>
          (a.dividentIncome || "").localeCompare(b.dividentIncome || ""),
        render: (text, record) =>
          isEditing(record) ? (
            <input
              className="roleInput"
              style={{ marginBottom: "0px" }}
              placeholder="Type"
              name="dividentIncome"
              value={editingRow && editingRow.dividentIncome}
              id="dividentIncome"
              onChange={(e) => {
                e.preventDefault();
                handleInputChange(e.target.value, "dividentIncome");
              }}
            />
          ) : text ? (
            <span style={{ color: "black", fontWeight: "bold" }}>{text}</span>
          ) : (
            "N/A"
          ),
        // render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Daily Gain/Loss",
        dataIndex: "dailyGainLoss",
        sorter: (a, b) => {
          const amountA = parseFloat(
            a.dayChange - (a.pricePerShare ? a.pricePerShare : a.dayChange)
          );
          const amountB = parseFloat(
            b.dayChange - (b.pricePerShare ? b.pricePerShare : b.dayChange)
          );
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        // render: (record) => (record ? record : "N/A"),
        render: (fileName, record) => {
          let result = calculateDayGainLoss(
            record.dayChange,
            record.pricePerShare ? record.pricePerShare : record.dayChange,
            record.shares,
            record
          );
          return result && result.dayGainLoss && result.dayGainLoss ? (
            <div>
              {result.daygainLossPercentage && (
                <span
                  style={{
                    color: result.daygainLossPercentage > 0 ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {result.daygainLossPercentage}%
                </span>
              )}
              <div style={{ color: result.dayGainLoss > 0 ? "green" : "red" }}>
                {result.dayGainLoss}
              </div>
            </div>
          ) : (
            "N/A"
          );
        },
      },
      {
        title: "Total Gain/Loss",
        dataIndex: "TotalGainLoss",
        sorter: (a, b) => {
          const amountA = parseFloat(
            a.approximateMarketValue -
              (a.averageCost ? a.averageCost : a.approximateMarketValue)
          );
          const amountB = parseFloat(
            b.approximateMarketValue -
              (b.averageCost ? b.averageCost : b.approximateMarketValue)
          );
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        // render: (record) => (record ? record : "N/A"),
        render: (fileName, record) => {
          let result = null;
          if (record.updatedAt) {
            result = calculateTotalGainLoss(
              record.approximateMarketValue && record.shares
                ? parseFloat(record.approximateMarketValue)
                : record.dayChange,
              record.totalCost
                ? record.totalCost
                : record.averageCost || 0,
              record.shares,
              record
            );
          } else {
            result = calculateTotalGainLoss(
              record.approximateMarketValue && record.shares
                ? parseFloat(record.approximateMarketValue) /
                    parseFloat(record.shares)
                : record.dayChange,
              record.totalCost
                ? record.totalCost
                : record.averageCost || 0,
              record.shares,
              record
            );
          }
          return result && result.totalGainLoss && result.totalGainLoss ? (
            <div>
              {result.gainLossPercentage && (
                <span
                  style={{
                    color: result.gainLossPercentage > 0 ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {result.gainLossPercentage}%
                </span>
              )}
              <div
                style={{ color: result.totalGainLoss > 0 ? "green" : "red" }}
              >
                {result.totalGainLoss}
              </div>
            </div>
          ) : (
            "N/A"
          );
        },
      },
      {
        title: "Total Return",
        dataIndex: "totalReturn",
        sorter: (a, b) => {
          const amountA = parseFloat(a.totalReturn);
          const amountB = parseFloat(b.totalReturn);
          // Toggle sorting order directly
          if (amountA < amountB) {
            return -1; // Sort in ascending order
          } else if (amountA > amountB) {
            return 1; // Sort in descending order
          } else {
            return 0; // Leave items unchanged if they are equal
          }
        },
        render: (text, record) =>
          isEditing(record) ? (
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span className="dollarSymbol">$</span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Total Return"
                name="totalReturn"
                value={editingRow && editingRow.totalReturn}
                id="totalReturn"
                onChange={(value) => {
                  handleInputChange(value, "totalReturn");
                }}
              />
            </div>
          ) : text ? (
            `$${parseFloat(text)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          ) : (
            "N/A"
          ),
        // render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Action",
        render: (record, index) => {
          // console.log("index...>>>",record.idx);
          const editable = isEditing(record);
          return editable ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
                // flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <button
                style={{ width: "fit-content", padding: "8px" }}
                className="savebutton"
                onClick={(e) => handleSaveDetails(e)}
              >
                Save
              </button>
              <button
                style={{ width: "fit-content", padding: "8px" }}
                className="cancelbutton"
                onClick={cancel}
              >
                Cancel
              </button>
            </div>
          ) : (
            <div>
              {" "}
              <div
                onClick={() => {
                  // setDropdown(!dropdown);
                }}
              >
                <DropDown1
                  trigger={["click"]}
                  overlay={
                    <Menu>
                      {/*<Menu.Item>
                    <div
                      onClick={() => {
                        getExpandedRow(record);
                      }}
                    >
                      Add Details
                    </div>
                  </Menu.Item> */}
                      <Menu.Item>
                        <div
                          onClick={() => {
                            edit(record);
                          }}
                        >
                          Update
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div
                          onClick={() => {
                            deleteStockSymbol(record.id);
                          }}
                        >
                          Delete
                        </div>
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <div
                    onClick={(e) => e.preventDefault()}
                    style={{
                      cursor: "pointer",
                      marginRight: "1rem",
                      padding: "0px 16px",
                      width: "5px",
                    }}
                  >
                    <a className="ant-dropdown-link">
                      <img src={menuIcon} alt="menuIcon"></img>
                    </a>
                  </div>
                </DropDown1>
              </div>
            </div>
          );
        },
      },
    ];
    const CustomExpandIcon = ({ expanded, onExpand, record }) => {
      return (
        <span
          onClick={(e) => {
            onExpand(record, e);
          }}
          style={{ cursor: "pointer" }}
        >
          {expanded ? <Icon type="down" /> : <Icon type="right" />}
        </span>
      );
    };
    return (
      <div style={view ? { pointerEvents: "none", opacity: 0.6 } : {}}>
      {console.log("StockData",StockData)}
        <Table
          className="components-table-demo-nested"
          columns={columns}
          expandedRowRender={(record) => {
            let nestedData =
              expandedTableData &&
              expandedTableData.filter(
                (item) => item.tickerSymbol === record.tickerSymbol
              );
            // console.log("nestedData",nestedData)
            return (
              <ExpandedRowRender
                record={record}
                addRow={addRow}
                setAddRow={setAddRow}
                expandedData={nestedData && nestedData}
                setExpandedRow={setExpandedRow}
                deleteStockItem={deleteStockItem}
                expandedRow={expandedRow}
                // getStocksDetails={getStocksDetails}
                handleExpandRowSave={handleExpandRowSave}
                handleExpandRowUpdate={handleExpandRowUpdate}
                getStocksDetails={getStocks}
                calculateRealizedGain={calculateRealizedGain}
                setLoading={setLoadingStocks}
              />
            );
          }}
          expandIcon={(props) => <CustomExpandIcon {...props} />}
          dataSource={StockData}
        />
      </div>
    );
  }
  const handleStockChange = (name, value) => {
    setStockBuyData({
      ...stockBuyData,
      [name]: value,
    });
  };
  const deleteStockSymbol = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this entire position?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        setStockList((prevStockList) =>
          prevStockList.filter((stock) => stock.id !== id)
        );

        setStockToSave((prevStockList) =>
          prevStockList.filter((stock) => stock.id !== id)
        );
        try {
          setLoadingStocks(true);
          const userToken = localStorage.getItem("userLoginToken");
          const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
          const queryParam =
            userRole === "Financial Advisor Client" ? `&clientId=${ID}` : "";
          const response = await axios.put(
            `${baseUrl}/stocks/delete?stockId=${id}${queryParam}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
            }
          );
          setLoadingStocks(false);
          // await getStocksDetails();
          // await getStocks();
        } catch (error) {
          console.log(error);
          setLoadingStocks(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Stock has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Stock is safe :)", "error");
      }
    });
  };
  const calculateShares1 = (data) => {
    const buys = data.filter((item) => item.buySell && item.buySell === "Buy");
    const sells = data.filter(
      (item) => item.buySell && item.buySell === "Sell"
    );

    const totalBuys = buys.reduce((sum, item) => sum + +item.shares, 0);
    const totalSells = sells.reduce((sum, item) => sum + +item.shares, 0);
    console.log("dataNNNN", data, totalBuys, totalSells);

    return totalBuys - totalSells;
  };
  const calculateAverageCost1 = (data) => {
    const buys = data.filter((item) => item.buySell && item.buySell === "Buy");
    const sells = data.filter(
      (item) => item.buySell && item.buySell === "Sell"
    );
    // Calculate total cost and total shares for buys and sells
    const totalBuys = buys && buys.reduce((sum, item) => sum + +item.shares, 0);
    const totalSells =
      sells && sells.reduce((sum, item) => sum + +item.shares, 0);

    const totalBuyCost =
      buys &&
      buys.reduce((sum, item) => sum + +item.shares * +item.pricePerShare, 0);
    const totalSellCost =
      sells &&
      sells.reduce((sum, item) => sum + +item.shares * +item.pricePerShare, 0);
    // Calculate overall total cost and total shares
    const overallTotalCost = totalBuyCost + totalSellCost;
    const overallTotalShares = totalBuys + totalSells;
    const totalAverageCost =
      overallTotalShares > 0 ? overallTotalCost / overallTotalShares : 0;
    // Calculate average cost for buys and sells
    const averageBuyCost = totalBuys > 0 ? totalBuyCost / totalBuys : 0;
    const averageSellCost = totalSells > 0 ? totalSellCost / totalSells : 0;
    const marketValueBuy =
      buys && buys.reduce((sum, item) => sum + +item.approximateMarketValue, 0);
    const marketValueSell =
      buys && buys.reduce((sum, item) => sum + +item.approximateMarketValue, 0);
    const totalMarketValue = marketValueBuy;
    console.log(
      "overallTotalCost",
      overallTotalCost,
      totalMarketValue,
      marketValueBuy,
      marketValueSell
    );
    return { totalMarketValue, totalAverageCost, overallTotalCost };
  };
  const deleteStockItem = async (id, record) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Stock Item?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        let nestedData =
          expandedTableData &&
          expandedTableData.filter(
            (item) => item.tickerSymbol === record.tickerSymbol
          );
        let updatedNestedData =
          nestedData &&
          nestedData.filter((item) => {
            // If the ids don't match, keep the item, otherwise remove it
            return item.id !== record.id;
          });
        let stockToUpdate =
          stockList &&
          stockList.find((item) => item.tickerSymbol === record.tickerSymbol);
        if (stockToUpdate) {
          let formula =
            updatedNestedData && calculateAverageCost1(updatedNestedData);
          stockToUpdate.shares =
            updatedNestedData && calculateShares1(updatedNestedData);
          stockToUpdate.averageCost = formula && formula.totalAverageCost;
          stockToUpdate.approximateMarketValue =
            formula && formula.totalMarketValue;
          stockToUpdate.totalCost = formula && formula.overallTotalCost;
          setStockList((prevStockList) =>
            prevStockList.map((stock) =>
              stock.id === stockToUpdate.id
                ? { ...stock, ...stockToUpdate }
                : stock
            )
          );
          setStockToSave((prevStockList) => {
            const existingRow = prevStockList.find(
              (stock) => stock.id === stockToUpdate.id
            );
            if (existingRow) {
              // Update existing row
              return prevStockList.map((stock) =>
                stock.id === stockToUpdate.id
                  ? { ...stock, ...stockToUpdate }
                  : stock
              );
            } else {
              // Add new row
              return [...prevStockList, stockToUpdate];
            }
          });
        }

        setExpandedTableData((prevStockList) =>
          prevStockList.filter((stock) => stock.id !== id)
        );

        setStockDetailsToSave((prevStockList) =>
          prevStockList.filter((stock) => stock.id !== id)
        );
        try {
          setLoadingStocks(true);
          const userToken = localStorage.getItem("userLoginToken");
          const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
          const queryParam =
            userRole === "Financial Advisor Client" ? `&clientId=${ID}` : "";
          const response = await axios.delete(
            `${baseUrl}/stocks?id=${id}${queryParam}`,
            {
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
            }
          );
          setLoadingStocks(false);
          // await getStocksDetails();
          // await getStocks();
        } catch (error) {
          console.log(error);
          setLoadingStocks(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Stock has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Stock is safe :)", "error");
      }
    });
  };
  const getStocksDetails = async () => {
    try {
      setLoadingStocks(true);
      const userToken = localStorage.getItem("userLoginToken");
      const queryParam =
        userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const response = await axios.get(`${baseUrl}/stocks${queryParam}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      console.log("response", response.data.data);
      if (
        response &&
        response.data &&
        response.data.status === 200 &&
        response.data.data
      ) {
        setExpandedTableData(response.data.data);
      }
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      console.error("Error fetching user data:", error);
    }
  };
  const createStocks = async () => {
    try {
      setLoadingStocks(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const response = await axios.get(`${baseUrl}/stocks/details/create`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      console.error("Error fetching user data:", error);
    }
  };
  const handleUpdateStockBuy = async (e) => {
    e.preventDefault();
    if (stockBuyData) {
      try {
        setLoadingStocks(true);
        const userToken = localStorage.getItem("userLoginToken");
        const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
        const queryParam =
          userRole === "Financial Advisor Client" ? `&clientId=${ID}` : "";
        const response = await axios.put(
          `${baseUrl}/stocks?stockId=${stockBuyData.id}${queryParam}`,
          stockBuyData,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        console.log("response", response);
        if (response && response.data && response.data.status === 200) {
          swal("Success", response.data.message, "success");
        }
        // await getStocksDetails();
        await getStocks();
        setLoadingStocks(false);
      } catch (error) {
        setLoadingStocks(false);
        if (error && error.data && error.data.message) {
          swal("Success", error.data.message, "success");
        }
        console.error("Error fetching user data:", error);
      }
    }
    setStockUpdate(false);
    setExpandedRow(null);
    setStockBuyData({});
  };
  const handleAddStockBuy = async (e) => {
    e.preventDefault();
    if (expandedRow && expandedRow.name) {
      const newStockData = {
        ...stockBuyData,
        tickerSymbol: expandedRow.ticker_symbol,
        parentShares: expandedRow.quantity,
        approximateMarketValue: expandedRow.institution_value,
      };
      try {
        setLoadingStocks(true);
        const userToken = localStorage.getItem("userLoginToken");
        const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
        const queryParam =
          userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
        const response = await axios.post(
          `${baseUrl}/stocks${queryParam}`,
          newStockData,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        console.log("response", response);
        if (response && response.data && response.data.status === 200) {
          // await getStocksDetails();
          await getStocks();
          swal("Success", response.data.message, "success");
        }
        if (response && response.data && response.data.status === 400) {
          swal("Error", response.data.message, "error");
        }
        setLoadingStocks(false);
      } catch (error) {
        setLoadingStocks(false);
        if (error && error.response && error.response.data) {
          swal("Error", error.response.data.message, "error");
        }
        console.error("Error fetching user data:", error);
      }
      // setExpandedTableData([
      //   ...expandedTableData,
      //   newStockData,
      // ]);
      // Optionally, clear stockBuyData
      setStockBuyData({});
    } else {
      console.error("expandedRow or expandedRow.name is not defined");
    }
    setExpandedRow(null);
  };
  const Stockcols = [
    {
      title: "Symbol",
      dataIndex: "01. symbol",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.stocks && record.stocks["01. symbol"] ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "#2a3da3", fontWeight: "bold" }}>
              {record.stocks["01. symbol"]}
            </div>
            {record.stocks["05. price"] && (
              <span
                style={{
                  color: "black",
                  background: "aquamarine",
                  fontWeight: "bold",
                }}
              >
                {record.stocks["05. price"]}
              </span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Day Change",
      dataIndex: "change",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.stocks && record.stocks["10. change percent"] ? (
          <div>
            <div
              style={{
                color:
                  record.stocks["10. change percent"] > 0 ? "#4cbb17" : "red",
                fontWeight: "bold",
              }}
            >
              {record.stocks["10. change percent"]}
            </div>
            {record.stocks["09. change"] && (
              <span
                style={{
                  color: record.stocks["09. change"] > 0 ? "#4cbb17" : "red",
                }}
              >
                {record.stocks["09. change"]}
              </span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Shares",
      dataIndex: "shares",
      render: (fileName, record) => {
        return record.stocks ? (
          <div>
            {record.stocks.userValues.shares && (
              <span style={{ color: "black", fontWeight: "bold" }}>
                {record.stocks.userValues.shares}
              </span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Average Cost",
      dataIndex: "costPerShare",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        return record.stocks ? (
          <div>
            {record.stocks.userValues.costPerShare && (
              <span style={{ color: "black", fontWeight: "bold" }}>
                {record.stocks.userValues.costPerShare}
              </span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Market Value",
      dataIndex: "approximateMarketValue",
      // render: (record) =>
      //   record
      //     ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      //     : "N/A",
      render: (fileName, record) => {
        return record.stocks ? (
          <div>
            {record.stocks.userValues.approximateMarketValue && (
              <span style={{ color: "black", fontWeight: "bold" }}>
                {record.stocks.userValues.approximateMarketValue}
              </span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Daily Gain/Loss",
      dataIndex: "dailyGainLoss",
      // render: (record) =>
      //   record ? moment(record).format("DD-MM-YYvYY") : "N/A",
      render: (fileName, record) => {
        let result =
          record.stocks &&
          calculateDayGainLoss(
            record.stocks["05. price"],
            record.stocks["08. previous close"],
            record.stocks.userValues.shares,
            record.stocks
          );
        return result && result.dayGainLoss && result.dayGainLoss ? (
          <div>
            {result.daygainLossPercentage && (
              <span
                style={{
                  color: result.daygainLossPercentage > 0 ? "green" : "red",
                  fontWeight: "bold",
                }}
              >
                {result.daygainLossPercentage}%
              </span>
            )}
            <div style={{ color: result.dayGainLoss > 0 ? "green" : "red" }}>
              {result.dayGainLoss}
            </div>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Total Gain/Loss",
      dataIndex: "TotalGainLoss",
      // render: (record) =>
      //   record
      //     ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
      //     : "N/A",
      render: (fileName, record) => {
        let result =
          record.stocks &&
          calculateTotalGainLoss(
            record.stocks["05. price"],
            record.stocks.userValues.costPerShare,
            record.stocks.userValues.shares,
            record.stocks
          );
        return result && result.totalGainLoss && result.totalGainLoss ? (
          <div>
            {result.gainLossPercentage && (
              <span
                style={{
                  color: result.gainLossPercentage > 0 ? "#4cbb17" : "red",
                  fontWeight: "bold",
                }}
              >
                {result.gainLossPercentage}%
              </span>
            )}
            <div
              style={{ color: result.totalGainLoss > 0 ? "#4cbb17" : "red" }}
            >
              {result.totalGainLoss}
            </div>
          </div>
        ) : (
          "N/A"
        );
      },
    },

    // {
    //   title: "Action",
    //   render: (record, index) => {
    //     // console.log("index...>>>",record.idx);
    //     return (
    //       <div>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginRight: "1rem" }}
    //           src={menuIcon}
    //           alt="menuIcon"
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const getOwnersDetails = async (page) => {
    try {
      // setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=30&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=30`,
        body: {},
      });
      if (datares && datares.records) {
        setOwnerList(datares.records);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };
  useEffect(() => {
    getUserDefined(1);
    getOwnersDetails(1);
    if (module === "Investment Portfolio" && id) {
      getStocks();
    }
  }, []);
  const getStocks = async () => {
    // await getStockData();
    // await createStocks();
    // await getStockStoreData();
    // await getStocksDetails();
    try {
      setLoadingStocks(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const queryParam =
        userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
      const response = await axios.post(
        `${baseUrl}/module/stocks${queryParam}`,
        { clientModuleId: id },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response);
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.stocks
      ) {
        let totalGainLoss = 0;
        let cashHolding = 0;
        let dayGain = 0;
        let currentPrice = 0;
        let closePrice = 0;
        let closeBasis = 0;
        let totalGainLossCalculate = 0;

        response.data.data.stocks &&
          response.data.data.stocks.forEach((stock) => {
            if (stock) {
              if (stock.tickerSymbol === "CUR:USD") {
                cashHolding += parseFloat(stock.approximateMarketValue || 0);
              }
              currentPrice += parseFloat(stock.pricePerShare || 0);
              closePrice += parseFloat(
                stock.closePrice || stock.pricePerShare || 0
              );
              if (stock.tickerSymbol !== "CUR:USD") {
                closeBasis += parseFloat(stock.approximateMarketValue || 0);
              }
              const gainLossDay =
                parseFloat(stock.pricePerShare || 0) -
                parseFloat(stock.closePrice || stock.pricePerShare || 0);
              const gainLossTotal =
                parseFloat(stock.pricePerShare || 0) -
                parseFloat(
                  stock.averageCost || stock.approximateMarketValue || 0
                );
              totalGainLoss += gainLossTotal;
              dayGain += gainLossDay;

              if (stock.updatedAt) {
                let result = calculateTotalGainLoss(
                  stock.approximateMarketValue && stock.shares
                    ? parseFloat(stock.approximateMarketValue)
                    : stock.dayChange,
                  stock.totalCost
                    ? stock.totalCost
                    : stock.averageCost || 0,
                  stock.shares,
                  stock
                );
                totalGainLossCalculate += result.totalGainLoss
                  ? +result.totalGainLoss
                  : 0;
              } else {
                let result = calculateTotalGainLoss(
                  stock.approximateMarketValue && stock.shares
                    ? parseFloat(stock.approximateMarketValue) /
                        parseFloat(stock.shares)
                    : stock.dayChange,
                  stock.totalCost
                    ? stock.totalCost
                    : stock.averageCost || 0,
                  stock.shares,
                  stock
                );
                totalGainLossCalculate += result.totalGainLoss
                  ? +result.totalGainLoss
                  : 0;
              }
            }
          });
        const gainLossDayPercentage = closePrice
          ? ((currentPrice - closePrice) / closePrice) * 100
          : 0;
        const gainLossTotalPercentage = closeBasis
          ? ((currentPrice - closeBasis) / closeBasis) * 100
          : 0;
        const totalPercentageGainorLossvalue = totalGainLossCalculate;
        const totalPercentageGainorLoss =
          (totalGainLossCalculate / closeBasis) * 100;
        const resultObject = {
          totalGainLoss,
          cashHolding,
          dayGain,
          gainLossDayPercentage,
          gainLossTotalPercentage,
          closeBasis,
          totalPercentageGainorLossvalue,
          totalPercentageGainorLoss,
        };
        setStockGain(resultObject);
        setStockList(response.data.data.stocks);
      }
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.details
      ) {
        setExpandedTableData(response.data.data.details);
      }
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      if (error && error.response && error.response.data) {
        // swal("Error", error.response.data.message, "error");
        console.error("Error fetching user data:", error.response.data.message);
      }
      console.error("Error fetching user data:", error);
    }
  };
  const addStockSymbol = async () => {
    try {
      setLoadingStocks(true);
      let jsonObj = {
        ...stockSymbolData,
        name: stockSymbolData.tickerSymbol,
        id: stockList.length,
        created: "newly",
      };

      setStockList((prevStockList) => [jsonObj, ...prevStockList]);
      setStockToSave((prevStockList) => [jsonObj, ...prevStockList]);

      // let payload={
      //   ...stockSymbolData,
      //   cmId:id,
      // }
      // const userToken = localStorage.getItem("userLoginToken");
      // const baseUrl = "https://sam.assetplanet.com/plaid-service";
      // const response = await axios.post(
      //   `${baseUrl}/stocks/manual`,
      //   payload,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userToken}`,
      //     },
      //   }
      // );
      // if (response && response.data && response.data.status === 200) {
      //   swal("Success", response.data.message, "success");
      //   setStockSymbolData(null)
      //   await getStocks();
      // }
      // if (response && response.data && response.data.status === 400) {
      //   swal("Error", response.data.message, "error");
      // }
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
    setStockSymbolData(null);
  };
  const [stockSymbolData, setStockSymbolData] = useState(null);
  const handleInputStock = (value, name) => {
    setStockSymbolData((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  // const getStockData = async () => {
  //   try {
  //     setLoading(true);
  //     let data = await MODULE_API.getStocks();
  //     if (data && data.data) {
  //       setStockList(data.data);
  //       console.log("data.datadata.data", data.data);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };
  const getStockData = async () => {
    try {
      setLoadingStocks(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const queryParam =
        userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
      const response = await axios.get(
        `${baseUrl}/plaid/tickers${queryParam}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response.data.data);
      if (
        response &&
        response.data &&
        response.data.status === 200 &&
        response.data.data
      ) {
        let totalGainLoss = 0;
        let cashHolding = 0;
        let dayGain = 0;
        let currentPrice = 0;
        let closePrice = 0;
        let closeBasis = 0;
        let totalGainLossCalculate = 0;

        response.data.data.forEach((stock) => {
          if (stock) {
            cashHolding += stock.institution_value;
            currentPrice += stock.institution_price;
            closePrice += stock.close_price
              ? stock.close_price
              : stock.institution_price;
            closeBasis += stock.cost_basis
              ? stock.cost_basis
              : stock.institution_value;
            const gainLossDay =
              stock.institution_price -
              (stock.close_price ? stock.close_price : stock.institution_price);
            const gainLossTotal =
              stock.institution_price -
              (stock.cost_basis ? stock.cost_basis : stock.institution_value);
            totalGainLoss += gainLossTotal;

            // Assuming day gain is the same as gain/loss for simplicity
            // This can be adjusted based on your specific definition of day gain
            dayGain += gainLossDay;

            if (stock.updatedAt) {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            } else {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue) /
                      parseFloat(stock.shares)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            }
          }
        });
        const gainLossDayPercentage =
          ((currentPrice - (closePrice ? closePrice : 0)) / closePrice) * 100;
        const gainLossTotalPercentage =
          ((currentPrice - (closeBasis ? closeBasis : 0)) / closeBasis) * 100;

        // console.log("stock1 Total Gain/Loss: ", totalGainLoss,gainLossDayPercentage,gainLossTotalPercentage);
        // console.log("stock1 Cash Holding: ", cashHolding);
        // console.log("stock1 Day Gain: ", dayGain);
        const totalPercentageGainorLossvalue = totalGainLossCalculate;
        const totalPercentageGainorLoss =
          (totalGainLossCalculate / closeBasis) * 100;
        const resultObject = {
          totalGainLoss,
          cashHolding,
          dayGain,
          gainLossDayPercentage,
          gainLossTotalPercentage,
          closeBasis,
          totalPercentageGainorLossvalue,
          totalPercentageGainorLoss,
        };
        setStockGain(resultObject);
        setStockList(response.data.data);
      }
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      console.error("Error fetching user data:", error);
    }
  };
  // const getStockStoreData = async () => {
  //   try {
  //     setLoading(true);
  //     const userToken = localStorage.getItem("userLoginToken");
  //     const baseUrl = "https://sam.assetplanet.com/plaid-service";
  //     const response = await axios.get(`${baseUrl}/stocks/get`, {
  //       headers: {
  //         Authorization: `Bearer ${userToken}`,
  //       },
  //     });
  //     console.log("response", response.data.data);
  //     if (
  //       response &&
  //       response.data &&
  //       response.data.status === 200 &&
  //       response.data.data
  //     ) {
  //       let totalGainLoss = 0;
  //       let cashHolding = 0;
  //       let dayGain = 0;
  //       let currentPrice = 0;
  //       let closePrice = 0;
  //       let closeBasis = 0;
  //       response.data.data.forEach(stock => {
  //         if (stock) {
  //             cashHolding += stock.institution_value;
  //             currentPrice += stock.institution_price;
  //             closePrice += stock.close_price ? stock.close_price : stock.institution_price;
  //             closeBasis += stock.cost_basis ? stock.cost_basis : stock.institution_value;
  //             const gainLossDay = (stock.institution_price - (stock.close_price ? stock.close_price : stock.institution_price));
  //             const gainLossTotal = (stock.institution_price - (stock.cost_basis ? stock.cost_basis : stock.institution_value));
  //             totalGainLoss += gainLossTotal;

  //             // Assuming day gain is the same as gain/loss for simplicity
  //             // This can be adjusted based on your specific definition of day gain
  //             dayGain += gainLossDay;
  //         }
  //     });
  //     const gainLossDayPercentage= ((currentPrice - (closePrice ? closePrice : 0))/closePrice) * 100;
  //     const gainLossTotalPercentage = ((currentPrice - (closeBasis ? closeBasis : 0))/closeBasis )* 100;

  //     console.log("stock1 Total Gain/Loss: ", totalGainLoss,gainLossDayPercentage,gainLossTotalPercentage);
  //     console.log("stock1 Cash Holding: ", cashHolding);
  //     console.log("stock1 Day Gain: ", dayGain);
  //     const resultObject = {
  //       totalGainLoss,
  //       cashHolding,
  //       dayGain,
  //       gainLossDayPercentage,
  //       gainLossTotalPercentage,
  //       closeBasis,
  //      };
  //       setStockGain(resultObject);
  //       setStockList(response.data.data);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching user data:", error);
  //   }
  // };
  const getStockStoreData = async () => {
    try {
      setLoadingStocks(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/plaid-service`;
      const queryParam =
        userRole === "Financial Advisor Client" ? `?clientId=${ID}` : "";
      const response = await axios.get(`${baseUrl}/stocks/get${queryParam}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      // console.log("response", response.data.data);
      if (
        response &&
        response.data &&
        response.data.status === 200 &&
        response.data.data
      ) {
        let totalGainLoss = 0;
        let cashHolding = 0;
        let dayGain = 0;
        let currentPrice = 0;
        let closePrice = 0;
        let closeBasis = 0;
        let totalGainLossCalculate = 0;

        response.data.data.forEach((stock) => {
          if (stock) {
            if (stock.tickerSymbol === "CUR:USD") {
              cashHolding += parseFloat(stock.approximateMarketValue || 0);
            }
            currentPrice += parseFloat(stock.pricePerShare || 0);
            closePrice += parseFloat(
              stock.closePrice || stock.pricePerShare || 0
            );
            if (stock.tickerSymbol !== "CUR:USD") {
              closeBasis += parseFloat(stock.approximateMarketValue || 0);
            }
            const gainLossDay =
              parseFloat(stock.pricePerShare || 0) -
              parseFloat(stock.closePrice || stock.pricePerShare || 0);
            const gainLossTotal =
              parseFloat(stock.pricePerShare || 0) -
              parseFloat(
                stock.averageCost || stock.approximateMarketValue || 0
              );
            totalGainLoss += gainLossTotal;

            // Assuming day gain is the same as gain/loss for simplicity
            // This can be adjusted based on your specific definition of day gain
            dayGain += gainLossDay;

            if (stock.updatedAt) {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            } else {
              let result = calculateTotalGainLoss(
                stock.approximateMarketValue && stock.shares
                  ? parseFloat(stock.approximateMarketValue) /
                      parseFloat(stock.shares)
                  : stock.dayChange,
                stock.totalCost
                  ? stock.totalCost
                  : stock.averageCost || 0,
                stock.shares,
                stock
              );
              totalGainLossCalculate += result.totalGainLoss
                ? +result.totalGainLoss
                : 0;
            }
          }
        });

        const gainLossDayPercentage = closePrice
          ? ((currentPrice - closePrice) / closePrice) * 100
          : 0;
        const gainLossTotalPercentage = closeBasis
          ? ((currentPrice - closeBasis) / closeBasis) * 100
          : 0;

        // console.log("Total Gain/Loss: ", totalGainLoss, gainLossDayPercentage, gainLossTotalPercentage);
        // console.log("Cash Holding: ", cashHolding);
        // console.log("Day Gain: ", dayGain);
        const totalPercentageGainorLossvalue = totalGainLossCalculate;
        const totalPercentageGainorLoss =
          (totalGainLossCalculate / closeBasis) * 100;
        const resultObject = {
          totalGainLoss,
          cashHolding,
          dayGain,
          gainLossDayPercentage,
          gainLossTotalPercentage,
          closeBasis,
          totalPercentageGainorLossvalue,
          totalPercentageGainorLoss,
        };

        setStockGain(resultObject);
        setStockList(response.data.data);
      }
      setLoadingStocks(false);
    } catch (error) {
      setLoadingStocks(false);
      console.error("Error fetching user data:", error);
    }
  };
  const calculateTotalGainLoss = (CurrentPrice, PurchasePrice, shares,record) => {
    // TOTAL PRICE
    // let gainLoss = (CurrentPrice - PurchasePrice) * shares;
    // console.log("recordNNN22",record,CurrentPrice,PurchasePrice)
    let gainLoss = CurrentPrice - PurchasePrice;
    // console.log("CurrentPrice",CurrentPrice,PurchasePrice)
    // TOTAL PERCENTAGE
    let gainLossPercentage =
      ((CurrentPrice - PurchasePrice) / PurchasePrice) * 100;
    return {
      totalGainLoss: gainLoss ? gainLoss.toFixed(2) : 0,
      gainLossPercentage: gainLossPercentage.toFixed(2),
    };
  };
  const calculateDayGainLoss = (CurrentPrice, closePrice, shares,record) => {
    // Day TOTAL PRICE
    // let gainLossDay = (CurrentPrice - closePrice) * shares;
    let gainLossDay = CurrentPrice - closePrice;

    // Day TOTAL PERCENTAGE
    let gainLossPercentageDay =
      ((CurrentPrice - closePrice) / closePrice) * 100;
    return {
      dayGainLoss: gainLossDay ? gainLossDay.toFixed(2) : 0,
      daygainLossPercentage: gainLossPercentageDay.toFixed(2),
    };
  };

  const handleAddStockSymbol = async () => {
    console.log("stock data", stockData);

    let stockPayload = {
      shares: stockData && +stockData.Shares,
      tickerSymbol: stockData && stockData["Ticker Symbol"],
      costPerShare: stockData && +stockData["Cost Per Share"],
      tradeDate: (stockData && stockData["Trade Date"]) || new Date(),
      approximateMarketValue:
        stockData && +stockData["Approximate Market Value"],
    };
    try {
      setLoading(true);
      console.log("obj in playload", stockPayload);
      const response = await MODULE_API.addStockShare(stockPayload);
      console.log("response", response);
      if (response.status === 200) {
        swal("Success", response.message, "success");
        // await getStockData();
        await getStockStoreData();
      }
      if (response.status === 400) {
        swal("Oops!", response.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }

    setStockCount(stockCount + 1);
    setStockData(null);
    setStockData({
      Shares: "",
      "Ticker Symbol": "",
      "Cost Per Share": "",
      "Trade Date": new Date(),
      "Approximate Market Value": "",
    });
  };
  // for stockmarket end code
  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      if (e.target.files) {
        setIsLoading(true);
        let uploadedFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file", uploadedFile);
        const name = uploadedFile.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        handleInputFields("File Name", fileName);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: uploadedFile.type,
        });
        const resupload = await axios.put(resdata.uploadUrl, uploadedFile, {
          headers: { "Content-type": uploadedFile.type },
        });
        setIsLoading(false);
        const imgUrl = resdata.uploadUrl.split("?")[0];
        return { imgUrl: imgUrl, fileName: fileName };
      }
    } catch (e) {
      console.log("error", e);
      swal("Error!", "File Size Too Big!", "error");
      setIsLoading(false);
    }
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  function handleInputFields(inputName, value) {
    setPayload((prevValue) => {
      let updatedValue = { ...prevValue };
      if (inputName === "Percent" || inputName === "Name") {
        // Check if inputName is Percent
        if (!updatedValue[inputName]) {
          updatedValue[inputName] = [value];
        } else {
          const index =
            countAdditionalPrincipalPayments - 1; /* specify your index */
          updatedValue[inputName][index] = value; // Update value at a specific index
        }
      } else if (
        (inputName === "Ticker Symbol" ||
          inputName === "Shares" ||
          inputName === "Cost Per Share" ||
          inputName === "Trade Date" ||
          inputName === "Approximate Market Value") &&
        activeTabName === "ADDITIONAL ASSET INFORMATION" &&
        stockMarket
      ) {
        // Check if inputName is payment
        setStockData({
          ...stockData,
          [inputName]: value,
        });
      } else if (
        inputName === "Rental Expenses" ||
        inputName === "Amount" ||
        inputName === "Frequency" ||
        inputName === "Start Date" ||
        inputName === "End Date"
      ) {
        // Check if inputName is payment
        if (!updatedValue[inputName]) {
          // If payment doesn't exist, create an array and store the value at index 0
          updatedValue[inputName] = [value];
        } else {
          // If payment exists, update the specific index or push the value to the array
          const index = investmentCount - 1; /* specify your index */
          if (!updatedValue[inputName][index]) {
            updatedValue[inputName][index] = 0; // Initialize with 0 if value is missing
          }
          updatedValue[inputName][index] = value; // Update value at a specific index
          // Or you can push the value to the end of the array
          // updatedValue[inputName].push(value);
          const amounts = updatedValue.Amount;
          // Initialize total amount
          let totalAmount = 0;
          // Loop through each amount and sum them up
          amounts &&
            amounts.forEach((amount) => {
              // Parse each amount as a number and add it to the total
              totalAmount += parseFloat(amount) || 0;
            });
          console.log("amounts", amounts, totalAmount, index, updatedValue);
          updatedValue["Total Monthly Expenses"] = totalAmount;
        }
      } else {
        updatedValue[inputName] = value; // Store value normally for non-payment inputs
      }

      return updatedValue;
    });
  }
  const handleDropdownChange = (inputName, value, label) => {
    setPayload({
      ...payload,
      ["Static"]: value,
      [inputName]: label,
    });
  };
  const DynamicComponentGenerator = (item) => {
    {
      if (
        activeTabName === "SELLING ASSET COSTS" ||
        activeTabName === "ASSET INFORMATION" ||
        activeTabName === "ASSET PERFORMANCE" ||
        activeTabName === "TAX AND LIQUIDITY"
      ) {
        if (dataObject[item]) {
          if (dataObject[item]["formGroupName"]) {
            return <></>;
          } else {
            return SubFieldGenerator(dataObject[item]);
          }
        }
      } else {
        if (data[item]) {
          if (data[item]["formGroupName"]) {
            return <></>;
          } else {
            return SubFieldGenerator(data[item]);
          }
        }
      }
      console.log("dartat for selling", dataObject);
      console.log("data[item]....", data[item]);
    }
  };
  const SubFieldGenerator = (item) => {
    console.log("item in SubFieldGenerator", item);
    const { view } = useParams();

    switch (item.dataType) {
      case "boolean":
        return (
          <React.Fragment>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
                display:
                  // Rule 1: Hide if Share with Financial Adviser and role restriction
                  item.name === "Share with Financial Adviser" &&
                  userRole !== "financial adviser client" &&
                  userRole !== "Active financial adviser client"
                    ? "none"
                    : // Rule 2: If Primary Residence, only show if payload value is false
                    item.name === "Is this undeveloped land?"
                    ? payload["Is this your primary residence?"] === "true" ||
                      payload["Is this your primary residence?"] === true ||
                      attributeValues["Is this your primary residence?"] ===
                        "true" ||
                      attributeValues["Is this your primary residence?"] ===
                        true
                      ? "none" // show
                      : "" // hide
                    : "",
                // display: item.name === "Share with Financial Adviser" && (userRole !== "financial adviser client" && userRole !== "Active financial adviser client") ? "none" : ""
              }}
            >
              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "fit-content",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <div>
                    {item.name}{" "}
                    {item.name === "This Asset is Liquid" && (
                      <span style={{ color: "red", fontSize: "20px" }}>*</span>
                    )}
                  </div>

                  {item &&
                    item.name &&
                    [
                      "This Asset has a Loan",
                      "This Asset produces Income",
                      "Share with Financial Adviser",
                    ].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "This Asset has a Loan"
                            ? "Assets_has_Loan"
                            : item.name === "This Asset produces Income"
                            ? "Assets_Produces_Income"
                            : "Assets_Share_with_Financial_Advisor"
                        }
                      />
                    )}
                </div>
                <Radio.Group
                  disabled={view}
                  style={{ marginTop: "0.5rem", width: "fit-content" }}
                  value={
                    values[item.name]
                      ? ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                      : ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                  }
                  size="large"
                  onChange={(e) => {
                    handleInputFields(item.name, e.target.value);
                    console.log("radio value", e.target.value);
                    values[item.name] = e.target.value;
                  }}
                >
                  <Radio.Button value="true">Yes</Radio.Button>
                  <Radio.Button value="false">No</Radio.Button>
                </Radio.Group>
              </label>
            </Styles.SubFormDiv>
          </React.Fragment>
        );

        break;
      case "string":
        return (
          <>
            {item.name === "Name" ||
            item.name === "Account Number" ||
            item.name === "Owner" ? (
              item.name === "Account Number" ? (
                <Styles.SubFormDiv
                  style={{
                    marginTop: "0.5rem",
                  }}
                >
                  <label>{item.name} (last four, at minimum)</label>
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                        // marginTop:"0.5rem"
                      }}
                      onChange={(e) => {
                        handleInputFields(item.name, e.target.value);
                      }}
                      value={
                        payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                    />
                  </Styles.InputBorder>
                </Styles.SubFormDiv>
              ) : item.name === "Owner" ? (
                <div style={{ width: "50%" }}>
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        columnGap: "3px",
                      }}
                    >
                      {item.name}{" "}
                      {item &&
                        item.name &&
                        [
                          "Name of Asset",
                          "Owner",
                          "Account Type/Titled",
                          "Held Where",
                        ].includes(item.name) && (
                          <ToolTipCreator
                            name={
                              item.name === "Name of Asset"
                                ? "Assets_Name_of_Asset"
                                : item.name === "Owner"
                                ? "Assets_Owner"
                                : item.name === "Held Where"
                                ? "Assets_Held_Where"
                                : "Assets_Account_Type_Titled"
                            }
                          />
                        )}
                    </label>
                    <div
                      style={{
                        width: "94%",
                      }}
                    >
                      <AutoComplete
                        className="custom-auto-select"
                        placeholder="Select Owner"
                        value={
                          payload && payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                        // When user types
                        onSearch={(text) => {
                          handleInputFields(item.name, text);
                        }}
                        // When user selects an option
                        onSelect={(value, option) => {
                          // handleInputFields(item.name, value);
                          if (value === "__add_new_owner__") {
                            setIsModalOpen(true);
                          } else {
                            handleInputFields(item.name, value);
                          }
                        }}
                        optionLabelProp="value"
                        // dataSource={
                        //   ownerList &&
                        //   ownerList.map((owner, idx) => (
                        //     <Options key={idx} value={owner.Name}>
                        //       {owner.Name} {owner.Type ? `(${owner.Type})` : ""}
                        //     </Options>
                        //   ))
                        // }
                        dataSource={[
                          ...ownerList.map((owner, idx) => (
                            <Options key={idx} value={owner.Name}>
                              {owner.Name} {owner.Type ? `(${owner.Type})` : ""}
                            </Options>
                          )),
                          <Options
                            value="__add_new_owner__"
                            key="add_new_owner"
                          >
                            + Add New Owner
                          </Options>,
                        ]}
                      >
                        <Input className="custom-auto-select-input" />
                      </AutoComplete>
                    </div>
                    {isModalOpen && (
                      <AddOwnerModal
                        title={"Add Owner Details"}
                        open={isModalOpen}
                        handleChange={handleChangeOwner}
                        handleCancel={handleCancel}
                        data={formDataOwner && formDataOwner}
                        handleSave={handleSave}
                      />
                    )}
                  </Styles.SubFormDiv>
                </div>
              ) : (
                <Styles.SubFormDiv
                  style={{
                    marginTop: "0.5rem",
                  }}
                >
                  <label>{item.name}</label>
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                        // marginTop:"0.5rem"
                      }}
                      onChange={(e) => {
                        // handleInputFields(item.name, result);
                        handleInputFields(item.name, e.target.value);
                        if (item.name === "Name") {
                          if (attributeValues[item.name]) {
                            const index = countAdditionalPrincipalPayments - 1;
                            attributeValues[item.name][index] = e.target.value;
                          }
                        }
                      }}
                      value={
                        item.name === "Name" && module
                          ? attributeValues[item.name] &&
                            attributeValues[item.name][0]
                          : payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                    />
                  </Styles.InputBorder>
                </Styles.SubFormDiv>
              )
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                  display:
                    ((payload["Is this your primary residence?"] === "true" ||
                      payload["Is this your primary residence?"] === true ||
                      attributeValues["Is this your primary residence?"] ===
                        "true" ||
                      attributeValues["Is this your primary residence?"] ===
                        true) &&
                      item.name === "Investment Property Address") ||
                    item.name === "File Name"
                      ? "none"
                      : "",
                }}
              >
                <label>
                  {item.name === "Early Withdrawl Penalty" ? (
                    <>
                      {item.name}{" "}
                      <img
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          showTooltipModal();
                        }}
                        src={helpIcon}
                        alt="help"
                      />
                      <Modal
                        centered
                        visible={tooltipModal}
                        footer={null}
                        onCancel={handleTooltipCancel}
                      >
                        <div className="modaltitle">
                          {" "}
                          Early Withdrawl Penalty
                        </div>
                        <div style={{}}>
                          <div className="">
                            <div className="inputTitle">
                              Type in the Penalty, whether it is a 10% IRA
                              penalty, 60 day CD interest penalty, $ 150 flat
                              savings account penalty, etc.
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        columnGap: "3px",
                      }}
                    >
                      {item.name}
                      {item &&
                        item.name &&
                        [
                          "Name of Asset",
                          "Owner",
                          "Account Type/Titled",
                          "Held Where",
                        ].includes(item.name) && (
                          <ToolTipCreator
                            name={
                              item.name === "Name of Asset"
                                ? "Assets_Name_of_Asset"
                                : item.name === "Owner"
                                ? "Assets_Owner"
                                : item.name === "Held Where"
                                ? "Assets_Held_Where"
                                : "Assets_Account_Type_Titled"
                            }
                          />
                        )}
                    </div>
                  )}
                </label>
                {item.name === "Ticker Symbol" ? (
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                      }}
                      onChange={(e) => {
                        handleInputFields(item.name, e.target.value);
                      }}
                      value={stockData && stockData["Ticker Symbol"]}
                    />
                  </Styles.InputBorder>
                ) : (
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                      }}
                      onChange={(e) => {
                        handleInputFields(item.name, e.target.value);
                        console.log("here in input");
                        if (attributeValues[item.name]) {
                          attributeValues[item.name] = e.target.value;
                        }
                      }}
                      value={
                        payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                    />
                  </Styles.InputBorder>
                )}
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "image":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder
              style={{
                alignItems: "center",
                background: "white",
                paddingInline: "1rem",
                display: "flex",
                justifyContent: "space-between",
                cursor: view ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!view) {
                  const inputEl = document.getElementById(item.name);
                  if (inputEl) inputEl.click();
                }
              }}
            >
              {/* Hidden file input */}
              <input
                id={item.name}
                type="file"
                disabled={view}
                style={{ display: "none" }}
                onChange={async (e) => {
                  const res = await handleFileChange(e);
                  handleInputFields(item.name, res.imgUrl);
                  handleInputFields("File Name", res.fileName);
                }}
              />

              {/* Label that displays status */}
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  cursor: view ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? (
                  <Spin />
                ) : payload[item.name] || attributeValues[item.name] ? (
                  <a
                    href={payload[item.name] || attributeValues[item.name]}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#2A3DA3",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e) => e.stopPropagation()} // prevent InputBorder click triggering input again
                  >
                    {payload["File Name"] ||
                      attributeValues["File Name"] ||
                      extractFileNameFromUrl(
                        payload[item.name] || attributeValues[item.name]
                      )}
                  </a>
                ) : (
                  <span style={{ color: "#999" }}>Choose file</span>
                )}

                <Icon
                  className=""
                  style={{
                    fontSize: "23px",
                    background: "#2A3DA3",
                    padding: "8px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                  type="upload"
                />
              </div>
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
        break;
      case "int":
        return (
          <>
            {item.name === "Percent" ||
            item.name === "Account Number" ||
            item.name === "Count" ||
            item.name === "Shares" ? (
              <>
                {item.name === "Percent" ? (
                  <>
                    <Styles.SubFormDiv
                      style={{
                        marginTop: "0.5rem",
                      }}
                    >
                      <label>{item.name}</label>
                      <Styles.InputBorder>
                        <input
                          readOnly={view}
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          style={{
                            outline: "none",
                            border: "none",
                            width: "98%",
                          }}
                          onChange={(e) => {
                            const result = e.target.value.replace(
                              /^-?\D*(\.\D{0,2})?$/,
                              ""
                            );
                            const re = /^\d*(?:\.\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              handleInputFields(item.name, result);
                              if (item.name === "Percent") {
                                if (attributeValues[item.name]) {
                                  const index =
                                    countAdditionalPrincipalPayments - 1;
                                  attributeValues[item.name][index] = result;
                                }
                              }
                            }
                          }}
                          step=".01"
                          value={
                            item.name === "Percent" && module
                              ? attributeValues[item.name] &&
                                attributeValues[item.name][0]
                              : payload[item.name]
                              ? payload[item.name]
                              : attributeValues[item.name]
                              ? attributeValues[item.name]
                              : ""
                          }
                        />
                        <span
                          style={{
                            fontSize: "20px",
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            color: "rgba(0, 0, 0, 0.65)",
                            background: "#fafafa",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            borderLeft: "1px solid #d9d9d9",
                          }}
                        >
                          %
                        </span>
                      </Styles.InputBorder>
                    </Styles.SubFormDiv>
                  </>
                ) : item.name === "Shares" ? (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label>{item.name}</label>
                    <Styles.InputBorder>
                      <input
                        readOnly={view}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        style={{
                          outline: "none",
                          border: "none",
                          width: "98%",
                        }}
                        onChange={(e) => {
                          const result = e.target.value.replace(/\D/g, "");
                          handleInputFields(item.name, result);
                        }}
                        value={stockData && stockData.Shares}
                      />
                    </Styles.InputBorder>
                  </Styles.SubFormDiv>
                ) : (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label>{item.name}</label>
                    <Styles.InputBorder>
                      <input
                        readOnly={view}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        style={{
                          outline: "none",
                          border: "none",
                          width: "98%",
                        }}
                        onChange={(e) => {
                          console.log("countContribution2", item.name);
                          // console.log(
                          //   "countContribution2new_ObjectContribution22",
                          //   newObjectContribution2
                          // );
                          // console.log(
                          //   "countContribution2_collapseObjects22",
                          //   collapseObjects2
                          // );
                          const result = e.target.value.replace(/\D/g, "");
                          handleInputFields(item.name, result);
                          if (item.name === "Percent") {
                            if (attributeValues[item.name]) {
                              const index =
                                countAdditionalPrincipalPayments - 1;
                              attributeValues[item.name][index] =
                                e.target.value;
                            }
                          }
                        }}
                        value={
                          item.name === "Percent" && module
                            ? attributeValues[item.name] &&
                              attributeValues[item.name][0]
                            : payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                      />
                    </Styles.InputBorder>
                  </Styles.SubFormDiv>
                )}
              </>
            ) : (
              <React.Fragment>
                {item.name === "Future Commitment Dollar Amount" &&
                  payload &&
                  (payload["Additional Future Committments"] === "yes" ||
                    payload["Additional Future Committments"] === "true") && (
                    <Styles.SubFormDiv
                      style={{
                        marginTop: "0.5rem",
                      }}
                    >
                      <label>{item.name}</label>
                      <Styles.InputBorder
                        style={{
                          paddingLeft:
                            item.name !== "Percent" || item.name === "Account"
                              ? "0"
                              : "1rem",
                          cursor:
                            item.name === "Estimated Unrealized Gain/Loss"
                              ? "not-allowed"
                              : "Pointer",
                          opacity:
                            item.name === "Estimated Unrealized Gain/Loss"
                              ? "0.6"
                              : "1",
                        }}
                      >
                        {item.name === "Approximate Market Value" ||
                        item.name === "Cost Per Share" ? (
                          <CurrencyCosts
                            readOnly={
                              view || item.name === "Estimated Unrealised Gains"
                            }
                            value={
                              item.name === "Approximate Market Value"
                                ? stockData &&
                                  stockData["Approximate Market Value"]
                                : item.name === "Cost Per Share"
                                ? stockData && stockData["Cost Per Share"]
                                : ""
                            }
                            onChange={(e) => {
                              const result = e.target.value.replace(/\D/g, "");
                              handleInputFields(item.name, result);
                            }}
                          />
                        ) : (
                          <CurrencyCosts
                            readOnly={
                              view ||
                              item.name === "Estimated Unrealized Gain/Loss"
                            }
                            value={
                              payload[item.name]
                                ? payload[item.name]
                                : attributeValues[item.name]
                                ? attributeValues[item.name]
                                : ""
                            }
                            onChange={(e) => {
                              const result = e.target.value.replace(/\D/g, "");
                              handleInputFields(item.name, result);
                            }}
                          />
                        )}
                      </Styles.InputBorder>
                    </Styles.SubFormDiv>
                  )}
                {item.name !== "Future Commitment Dollar Amount" && (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                      display:
                        (payload["Is this your primary residence?"] ===
                          "true" ||
                          payload["Is this your primary residence?"] === true ||
                          attributeValues["Is this your primary residence?"] ===
                            "true" ||
                          attributeValues["Is this your primary residence?"] ===
                            true) &&
                        (item.name === "Down Payment" ||
                          item.name === "Monthly Lease/Rent Collected" ||
                          item.name === "Total Monthly Expenses" ||
                          item.name === "Purchase Price of Property")
                          ? "none"
                          : "",
                    }}
                  >
                    <label>
                      {(item.name && item.name === "Cost Basis" && (
                        <span>
                          Cost Basis{" "}
                          <span style={{ fontWeight: "bold" }}>
                            (Purchase Price){" "}
                          </span>
                        </span>
                      )) ||
                        (item.name && item.name === "Monetary Value" && (
                          <React.Fragment>
                            Monetary Value
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                showTooltipModal();
                              }}
                              src={helpIcon}
                              alt="help"
                            />
                            <Modal
                              centered
                              visible={tooltipModal}
                              footer={null}
                              onCancel={handleTooltipCancel}
                            >
                              <div className="modaltitle"> Monetary Value</div>
                              <div style={{}}>
                                <div className="">
                                  <div className="inputTitle">
                                    This field can be filled in by you or
                                    calculated based on Cost Basis information
                                    and Rate of Return. Clicking the Calculate
                                    button will overwrite any information stored
                                    here and perform the daily compounding
                                    calculation, provided Cost Basis, Cost Basis
                                    Date and Rate of Return are completed.
                                  </div>
                                </div>
                              </div>
                            </Modal>
                          </React.Fragment>
                        )) ||
                        item.name}
                    </label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "end",
                        width: item.name === "Monetary Value" ? "90%" : "100%",
                      }}
                    >
                      <Styles.InputBorder
                        style={{
                          paddingLeft:
                            item.name !== "Percent" ||
                            item.name === "Account" ||
                            item.name === "Monetary Value"
                              ? "0"
                              : "1rem",
                          cursor:
                            item.name === "Estimated Unrealized Gain/Loss" ||
                            item.name === "Monetary Value"
                              ? "not-allowed"
                              : "Pointer",
                          opacity:
                            item.name === "Estimated Unrealized Gain/Loss" ||
                            item.name === "Monetary Value"
                              ? "0.6"
                              : "1",
                        }}
                      >
                        <CurrencyCosts
                          readOnly={
                            view ||
                            item.name === "Estimated Unrealized Gain/Loss" ||
                            item.name === "Monetary Value"
                          }
                          value={
                            item.name === "Amount" && module
                              ? attributeValues[item.name] &&
                                attributeValues[item.name][0]
                              : payload[item.name]
                              ? payload[item.name]
                              : attributeValues[item.name]
                              ? attributeValues[item.name]
                              : ""
                          }
                          // value={
                          //   payload[item.name]
                          //     ? payload[item.name]
                          //     : attributeValues[item.name]
                          //     ? attributeValues[item.name]
                          //     : ""
                          // }
                          onChange={(e) => {
                            const result = e.target.value.replace(/\D/g, "");
                            handleInputFields(item.name, result);
                            if (attributeValues && attributeValues[item.name]) {
                              attributeValues[item.name] = e.target.value;
                            }
                          }}
                        />
                      </Styles.InputBorder>
                      {item.name === "Monetary Value" && (
                        <Button
                          onClick={calculateMonetoryValue}
                          style={{
                            backgroundColor: "#2a3da3",
                            color: "white",
                            borderRadius: "8px",
                            fontFamily: "Poppins",
                            width: "130px",
                            height: "3.5rem",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Calculate
                        </Button>
                      )}
                    </div>
                  </Styles.SubFormDiv>
                )}
              </React.Fragment>
            )}
          </>
        );

        break;
      case "float":
        return (
          <>
            {item.name === "Static" ? (
              <>
                {(payload["Rate Of Return (if applicable)"] === "Static" ||
                  attributeValues["Rate Of Return (if applicable)"] ===
                    "Static") &&
                payload["Rate Of Return (if applicable)"] !== "User Defined" &&
                (attributeValues["Rate Of Return (if applicable)"] !==
                  "User Defined" ||
                  payload["Rate Of Return (if applicable)"] !==
                    "User Defined") ? (
                  <Styles.SubFormDiv
                    style={{
                      marginTop: "0.5rem",
                    }}
                  >
                    <label>{item.name}</label>
                    <Styles.InputBorder>
                      <input
                        readOnly={view}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        style={{
                          outline: "none",
                          border: "none",
                          width: "98%",
                        }}
                        onChange={(e) => {
                          const result = e.target.value.replace(
                            /^-?\D*(\.\D{0,2})?$/,
                            ""
                          );
                          const re = /^\d*(?:\.\d{0,2})?$/;
                          // if (
                          //   e.target.value === "" ||
                          //   re.test(e.target.value)
                          // ) {
                          handleInputFields(item.name, e.target.value);
                          if (attributeValues && attributeValues[item.name]) {
                            attributeValues[item.name] = e.target.value;
                          }
                          // }
                        }}
                        step=".01"
                        value={
                          payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                      />
                      <span
                        style={{
                          fontSize: "20px",
                          padding: "8px",
                          display: "flex",
                          alignItems: "center",
                          color: "rgba(0, 0, 0, 0.65)",
                          background: "#fafafa",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderLeft: "1px solid #d9d9d9",
                        }}
                      >
                        %
                      </span>
                    </Styles.InputBorder>
                  </Styles.SubFormDiv>
                ) : (
                  <></>
                )}
              </>
            ) : item.name === "Monetary Value" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>
                  <React.Fragment>
                    {item.name}
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        showTooltipModal();
                      }}
                      src={helpIcon}
                      alt="help"
                    />
                    <Modal
                      centered
                      visible={tooltipModal}
                      footer={null}
                      onCancel={handleTooltipCancel}
                    >
                      <div className="modaltitle"> Monetary Value</div>
                      <div style={{}}>
                        <div className="">
                          <div className="inputTitle">
                            This field can be filled in by you or calculated
                            based on Cost Basis information and Rate of Return.
                            Clicking the Calculate button will overwrite any
                            information stored here and perform the daily
                            compounding calculation, provided Cost Basis, Cost
                            Basis Date and Rate of Return are completed.
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </React.Fragment>
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    width: item.name === "Monetary Value" ? "90%" : "100%",
                  }}
                >
                  <Styles.InputBorder
                    style={{
                      paddingLeft:
                        item.name !== "Percent" ||
                        item.name === "Account" ||
                        item.name === "Monetary Value"
                          ? "0"
                          : "1rem",
                      cursor:
                        item.name === "Estimated Unrealized Gain/Loss" ||
                        item.name === "Monetary Value"
                          ? "not-allowed"
                          : "Pointer",
                      opacity:
                        item.name === "Estimated Unrealized Gain/Loss" ||
                        item.name === "Monetary Value"
                          ? "0.6"
                          : "1",
                    }}
                  >
                    <CurrencyCosts
                      readOnly={view || item.name === "Monetary Value"}
                      value={
                        payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                      onChange={(e) => {
                        const result = e.target.value.replace(/\D/g, "");
                        handleInputFields(item.name, result);
                      }}
                    />
                  </Styles.InputBorder>
                  <Button
                    onClick={calculateMonetoryValue}
                    style={{
                      backgroundColor: "#2a3da3",
                      color: "white",
                      borderRadius: "8px",
                      fontFamily: "Poppins",
                      width: "130px",
                      height: "3.5rem",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Calculate
                  </Button>
                </div>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                  display:
                    item.name === "Cash Holding"
                      ? "none"
                      : item.name === "Loan Interest Rate" &&
                        (payload["This Asset has a Loan"] === "true" ||
                          payload["This Asset has a Loan"] === true ||
                          attributeValues["This Asset has a Loan"] === "true" ||
                          attributeValues["This Asset has a Loan"] === true)
                      ? ""
                      : "none",
                }}
              >
                <label>{item.name}</label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                    }}
                    onChange={(e) => {
                      const result = e.target.value.replace(
                        /^(-?\D+(\.\D{0,2})?)$/,
                        ""
                      );
                      // console.log("result",result);
                      const re = /^\d*(?:\.\d{0,2})?$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        handleInputFields(item.name, result);
                      }
                    }}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                  {(item.name === "Enter Portfolio % of Gold" ||
                    item.name === "Enter Portfolio % of Cash" ||
                    item.name === "Enter Portfolio % of Bonds" ||
                    item.name === "Enter Portfolio % of Real Estate" ||
                    item.name === "Loan Interest Rate" ||
                    item.name === "Enter Portfolio % of S&P 500") && (
                    <span
                      style={{
                        fontSize: "20px",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        color: "rgba(0, 0, 0, 0.65)",
                        background: "#fafafa",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderLeft: "1px solid #d9d9d9",
                      }}
                    >
                      %
                    </span>
                  )}
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            )}
          </>
        );

      case "Formula":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label>{item.name}</label>
              <Styles.InputBorder>
                <input
                  readOnly={view}
                  // type="number"
                  // pattern="[0-9]*"
                  disabled={true}
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  style={{
                    outline: "none",
                    border: "none",
                    width: "98%",
                  }}
                  onChange={(e) => {
                    const result = e.target.value.replace(/\D/g, "");
                    handleInputFields(item.name, result);
                  }}
                  value={
                    payload[item.name] && payload[item.name] != 0
                      ? payload[item.name]
                      : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                  }
                />
                {item.name === "Total Percentage" && (
                  <span
                    style={{
                      fontSize: "20px",
                      padding: "8px",
                      display: "flex",
                      alignItems: "center",
                      color: "rgba(0, 0, 0, 0.65)",
                      background: "#fafafa",
                      borderTopRightRadius: "8px",
                      borderBottomRightRadius: "8px",
                      borderLeft: "1px solid #d9d9d9",
                    }}
                  >
                    %
                  </span>
                )}
              </Styles.InputBorder>
              {item.name === "Total Percentage" &&
                payload &&
                payload["Total Percentage"] === "error" && (
                  <span
                    style={{
                      fontSize: "16px",
                      // padding: "8px",
                      // display: "flex",
                      // alignItems: "center",
                      color: "red",
                    }}
                  >
                    Total percentage should not exceed 100
                  </span>
                )}
            </Styles.SubFormDiv>
          </>
        );

        break;
      case "dropdown":
        return (
          <>
            {item.name === "Professional Prediction" ||
            item.name === "Monte Carlo" ||
            item.name === "User Defined" ||
            item.name === "Rate Of Return (if applicable)" ? (
              <>
                {item.name === "Rate Of Return (if applicable)" && (
                  <div
                    style={{
                      marginTop: "0.5rem",
                      width: "50%",
                    }}
                  >
                    <label>{item.name}</label>
                    <div style={{ width: "94%" }}>
                      <DropDown
                        readOnly={view}
                        style={defaultStyles.styles.dropDown.m_smallDropdown1}
                        listingStyle={{
                          ...defaultStyles.styles.dropDown.m_smallDropdown2,
                          height: "auto",
                        }}
                        name={item.name}
                        title={item.name}
                        list={
                          item.attribute_default_values &&
                          item.attribute_default_values.filter(
                            (attribute) =>
                              attribute.value === "Static" ||
                              attribute.value === "User Defined"
                          )
                        }
                        displayKey="value"
                        disableSearch={false}
                        setSelectedItem={({ name, value }) => {
                          handleInputFields([name], value);
                        }}
                        defaultValue={
                          payload && payload[item.name]
                            ? payload[item.name]
                            : attributeValues[item.name]
                            ? attributeValues[item.name]
                            : ""
                        }
                      />
                    </div>
                  </div>
                )}
                {item.name === "User Defined" &&
                  (payload["Rate Of Return (if applicable)"] ===
                    "User Defined" ||
                    attributeValues["Rate Of Return (if applicable)"] ===
                      "User Defined") &&
                  payload["Rate Of Return (if applicable)"] !== "Static" &&
                  (payload["Rate Of Return (if applicable)"] !== "Static" ||
                    attributeValues["Rate Of Return (if applicable)"] !==
                      "Static") && (
                    <div style={{ width: "48%" }}>
                      <Styles.SubFormDiv
                        style={{
                          marginTop: "0.5rem",
                        }}
                      >
                        <label>{item.name}</label>
                        <div style={{ width: "94%" }}>
                          <Select
                            className="custom-userdefined-select"
                            showSearch
                            placeholder="-Select-"
                            onPopupScroll={handlePopupScroll}
                            value={
                              payload && payload[item.name]
                                ? payload[item.name]
                                : attributeValues[item.name]
                                ? attributeValues[item.name]
                                : ""
                            }
                            onChange={(value, option) => {
                              const label = option.props.children;
                              handleDropdownChange(item.name, value, label);
                            }}
                          >
                            {userDefined &&
                              userDefined.map((item, index) => (
                                <Option
                                  key={index}
                                  value={item.percentage}
                                  label={item.year}
                                >
                                  {item.year}
                                </Option>
                              ))}
                          </Select>
                        </div>
                      </Styles.SubFormDiv>
                    </div>
                  )}
              </>
            ) : item.name === "incomeModule" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                  display:
                    (payload["This Asset produces Income"] === "true" ||
                      payload["This Asset produces Income"] === true ||
                      attributeValues["This Asset produces Income"] ===
                        "true" ||
                      attributeValues["This Asset produces Income"] === true) &&
                    item.name === "incomeModule"
                      ? ""
                      : "none",
                }}
              >
                <label>Select Income Module</label>
                <div style={{ width: "94%" }}>
                  <DropDown
                    readOnly={view}
                    style={defaultStyles.styles.dropDown.m_smallDropdown1}
                    listingStyle={{
                      ...defaultStyles.styles.dropDown.m_smallDropdown2,
                      height: "auto",
                    }}
                    name={item.name}
                    title={item.name}
                    list={item.attribute_default_values}
                    displayKey="value"
                    disableSearch={false}
                    setSelectedItem={({ name, value }) => {
                      handleInputFields(name, value);
                    }}
                    defaultValue={
                      (item.name === "Frequency" ||
                        item.name === "Rental Expenses" ||
                        item.name === "Contribution or Distribution") &&
                      module
                        ? attributeValues[item.name] &&
                          attributeValues[item.name][0]
                        : values && values[item.name]
                        ? values[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                </div>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                  display:
                    (payload["Is this your primary residence?"] === "true" ||
                      payload["Is this your primary residence?"] === true ||
                      attributeValues["Is this your primary residence?"] ===
                        "true" ||
                      attributeValues["Is this your primary residence?"] ===
                        true) &&
                    (item.name === "Residential or Commercial" ||
                      item.name === "Type of Property")
                      ? "none"
                      : "",
                }}
              >
                <label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    {item.name}
                    {item &&
                      item.name &&
                      [
                        "Taxability while Owned",
                        "Taxability on Distribution",
                        "Status of Asset",
                      ].includes(item.name) && (
                        <ToolTipCreator
                          name={
                            item.name === "Taxability while Owned"
                              ? "Assets_Taxability_while_Owned"
                              : item.name === "Taxability on Distribution"
                              ? "Assets_Taxability_on_Distribution"
                              : "Assets_Status_of_Asset"
                          }
                        />
                      )}
                  </div>
                </label>
                <div style={{ width: "94%" }}>
                  <DropDown
                    readOnly={view}
                    style={defaultStyles.styles.dropDown.m_smallDropdown1}
                    listingStyle={{
                      ...defaultStyles.styles.dropDown.m_smallDropdown2,
                      height: "auto",
                    }}
                    name={item.name}
                    title={item.name}
                    list={
                      item.name === "Type of Property"
                        ? [...item.attribute_default_values].sort(
                            (a, b) => a.id - b.id
                          ) // sort by id desc
                        : item.attribute_default_values
                    }
                    displayKey="value"
                    disableSearch={false}
                    setSelectedItem={({ name, value }) => {
                      handleInputFields(name, value);
                    }}
                    defaultValue={
                      (item.name === "Frequency" ||
                        item.name === "Rental Expenses" ||
                        item.name === "Contribution or Distribution") &&
                      module
                        ? attributeValues[item.name] &&
                          attributeValues[item.name][0]
                        : values && values[item.name]
                        ? values[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                    // defaultValue={
                    //   payload && payload[item.name]
                    //     ? payload[item.name]
                    //     : attributeValues[item.name]
                    //     ? attributeValues[item.name]
                    //     : ""
                    // }
                  />
                </div>
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "date":
        return (
          <>
            {item.name === "When Future Commitment Due" &&
              payload &&
              (payload["Additional Future Committments"] === "yes" ||
                payload["Additional Future Committments"] === "true") && (
                <Styles.SubFormDiv
                  style={{
                    marginTop: "0.5rem",
                  }}
                >
                  <label>{item.name}</label>
                  <Styles.InputBorder
                    style={{
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    <DatePicker
                      disabled={view}
                      className="ant-calendar-picker-input ant-input"
                      format={"MM/DD/YYYY"}
                      style={{
                        outline: "none",
                        border: "none",
                        borderRadius: "0.5rem",
                      }}
                      placeholder="Select Purchase Date"
                      // onChange={(e) => {
                      //   if (e !== null) handleInputFields(item.name, e.toString());
                      // }}
                      // defaultValue={
                      //   payload[item.name]
                      //     ? moment(payload[item.name])
                      //     : moment(payload[item.name] || new Date())
                      // }
                      onChange={(e) => {
                        if (e !== null) {
                          handleInputFields(item.name, e.toString());
                          values[item.name] = e.toString();
                        }
                      }}
                      value={
                        values[item.name]
                          ? moment(values[item.name])
                          : moment(attributeValues[item.name] || new Date())
                      }
                      // defaultValue={
                      //   payload[item.name] ? moment(payload[item.name]) : moment()
                      // }
                    />
                  </Styles.InputBorder>
                </Styles.SubFormDiv>
              )}
            {item.name !== "When Future Commitment Due" && (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                  display:
                    item.name === "Loan End Date"
                      ? payload["This Asset has a Loan"] === "true" ||
                        payload["This Asset has a Loan"] === true ||
                        attributeValues["This Asset has a Loan"] === "true" ||
                        attributeValues["This Asset has a Loan"] === true
                        ? ""
                        : "none"
                      : "",
                }}
              >
                <label>
                  {item.name === "Cost Basis Date" ? (
                    <span>
                      Cost Basis Date{" "}
                      <span style={{ fontWeight: "bold" }}>
                        (Purchase Date){" "}
                      </span>
                    </span>
                  ) : (
                    item.name
                  )}
                </label>
                <Styles.InputBorder
                  style={{
                    display: "flex",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {item.name === "Trade Date" ? (
                    <DatePicker
                      disabled={view}
                      className="ant-calendar-picker-input ant-input"
                      format={"MM/DD/YYYY"}
                      style={{
                        outline: "none",
                        border: "none",
                        borderRadius: "0.5rem",
                      }}
                      placeholder="Select Purchase Date"
                      onChange={(e) => {
                        if (e !== null) {
                          handleInputFields(item.name, e.toString());
                          values[item.name] = e.toString();
                        }
                      }}
                    />
                  ) : (
                    <DatePicker
                      disabled={view}
                      className="ant-calendar-picker-input ant-input"
                      format={"MM/DD/YYYY"}
                      style={{
                        outline: "none",
                        border: "none",
                        borderRadius: "0.5rem",
                      }}
                      placeholder="Select Purchase Date"
                      // onChange={(e) => {
                      //   if (e !== null) handleInputFields(item.name, e.toString());
                      // }}
                      // defaultValue={
                      //   payload[item.name]
                      //     ? moment(payload[item.name])
                      //     : moment(payload[item.name] || new Date())
                      // }
                      onChange={(e) => {
                        if (e !== null) {
                          handleInputFields(item.name, e.toString());
                          values[item.name] = e.toString();
                        }
                      }}
                      // defaultValue={
                      //   (item.name === "End Date" ||
                      //     item.name === "Start Date") &&
                      //   module
                      //     ? attributeValues[item.name] &&
                      //       moment(attributeValues[item.name][0] || new Date())
                      //     : values[item.name]
                      //     ? moment(values[item.name])
                      //     : moment(payload[item.name] || new Date())
                      // }
                      // value={payload[item.name] && moment(payload[item.name]) || moment(attributeValues[item.name])}
                      value={
                        (item.name === "End Date" ||
                          item.name === "Start Date") &&
                        module
                          ? payload[item.name]
                            ? moment(
                                payload[item.name][0] ||
                                  attributeValues[item.name][0] ||
                                  new Date()
                              )
                            : moment(new Date())
                          : payload[item.name] &&
                            payload[item.name] !== "Trade Date"
                          ? moment(
                              payload[item.name] || attributeValues[item.name]
                            )
                          : moment(
                              payload[item.name] ||
                                attributeValues[item.name] ||
                                new Date()
                            )
                      }
                      // value={
                      //   values[item.name]
                      //     ? moment(values[item.name])
                      //     : moment(attributeValues[item.name] || new Date())
                      // }
                      // defaultValue={
                      //   payload[item.name] ? moment(payload[item.name]) : moment()
                      // }
                    />
                  )}
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;

      default:
        console.error("invalid DataType Detected :::: ", item.dataType);

        break;
    }
  };

  const { module } = useParams();
  const { id } = useParams();

  const thisContributionArray = [
    "Precious Metals",
    "Bonds - Int Long Term",
    "Cash or CD's T-Bills",
    "Indexes, ETF's and Mutual Funds",
    "Private Placement and VC",
    "Investment Portfolio",
    "Trust Deeds",
    "User Defined Portfolio Allocation",
    "Business Interest",
    "Club Membership",
    "Cryptocurrency",
  ];

  const groupedFieldsPage = (fieldss) => {
    if (advancedInformation) {
      console.log("livestockFlieds", advancedInformation);

      let temp = Object.values(fieldss)[0];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (assetBeneficiaryAssignment) {
      let temp = Object.values(fieldss)[0];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (ContributionOrDistribution && thisContributionArray.includes(module)) {
      let temp = Object.values(fieldss)[0];
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (stockMarket) {
      let temp = Object.values(fieldss)[0];
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (investmentProperty) {
      let temp = Object.values(fieldss)[0];
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
    if (liveStock) {
      console.log("livestockFlieds", liveStock);
      let temp = Object.values(fieldss)[0];
      // console.log("tempaaaaaaaaaaa", temp);
      console.log("temppppp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("Object.values(fieldss)", temmp);
      return temmp;
    }
  };

  const { view } = useParams();

  const [
    objectAssetBeneficiaryAssignment,
    setObjectAssetBeneficiaryAssignment,
  ] = useState({});
  const [
    countAdditionalPrincipalPayments,
    setCountAdditionalPrincipalPayments,
  ] = useState(1);
  const [
    collapseAssetBeneficiaryAssignment,
    setCollapseAssetBeneficiaryAssignment,
  ] = useState([]);

  const [objectInvestment, setObjectInvestment] = useState({});
  const [investmentCount, setInvestmentCount] = useState(1);
  const [collapseinvestment, setCollapseInvestment] = useState([]);

  const handleNewAssetBeneficiaryAssignment = () => {
    setObjectAssetBeneficiaryAssignment(objectAssetBeneficiaryAssignment);
    setCollapseAssetBeneficiaryAssignment((prevObjects) => [
      ...prevObjects,
      objectAssetBeneficiaryAssignment,
    ]);
    setCountAdditionalPrincipalPayments(countAdditionalPrincipalPayments + 1);
  };
  const handleNewInvestment = () => {
    setObjectInvestment(objectInvestment);
    setCollapseInvestment((prevObjects) => [...prevObjects, objectInvestment]);
    setInvestmentCount(investmentCount + 1);
  };

  //
  //

  const [
    objectContributionOrDistribution,
    setObjectContributionOrDistribution,
  ] = useState({});
  const [countContributionOrDistribution, setCountContributionOrDistribution] =
    useState(1);
  const [
    collapseContributionOrDistribution,
    setCollapseContributionOrDistribution,
  ] = useState([]);

  const handleNewContributionOrDistribution = () => {
    setObjectContributionOrDistribution(objectContributionOrDistribution);
    setCollapseContributionOrDistribution((prevObjects) => [
      ...prevObjects,
      objectContributionOrDistribution,
    ]);
    setCountContributionOrDistribution(countContributionOrDistribution + 1);
  };
  useEffect(() => {
    let totalAmount = 0;
    if (module === "Real Estate") {
      if (
        (payload && payload["Amount"]) ||
        (attributeValues && attributeValues["Amount"])
      ) {
        totalAmount =
          payload["Amount"] && Array.isArray(payload["Amount"])
            ? payload["Amount"].reduce(
                (acc, curr) => acc + parseFloat(+curr || 0),
                0
              )
            : 0;
        setPayload((prevValue) => {
          return {
            ...prevValue,
            ["Total Monthly Expenses"]: totalAmount,
          };
        });
      }
    }
  }, [
    payload["Amount"],
    attributeValues["Amount"],
    investmentCount,
    collapseinvestment,
  ]);
  return (
    <div style={{ position: "relative" }}>
      <>
        <div style={{ margin: " 0 3rem" }}>
          <div
            style={{
              fontFamily: "Poppins",
              fontSize: "24px",
              fontWeight: "500",
              color: "#030229",
              textAlign: "center",
              marginBottom: "8px",
            }}
          >
            {module}
          </div>
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <h1
              style={{
                fontFamily: "Poppins",
                fontSize: "20px",
                fontWeight: "500",
                color: "#030229",
              }}
            >
              {title}
            </h1>
            <h1
              style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "500",
                color: "grey",
              }}
            >
              {view ? "(Read Only)" : ""}
            </h1>
          </div>
          <h5>
            {title &&
              title === "SELLING ASSET COSTS" &&
              "These fields should only be used if the Asset is sold or being sold. If that does not apply here, please press Next on the bottom of this page."}
          </h5>
        </div>
        <Styles.FormDiv>
          {console.log("item in mapppppccc", inputFields, orderOfNames)}
          {activeTabName === "SELLING ASSET COSTS" &&
            orderOfNames &&
            orderOfNames.map((item, indx) => {
              return DynamicComponentGenerator(item);
            })}
          {activeTabName === "ASSET INFORMATION" &&
            orderOfNamesInfo &&
            orderOfNamesInfo.map((item, indx) => {
              return DynamicComponentGenerator(item);
            })}
          {activeTabName === "ASSET PERFORMANCE" &&
            orderOfNamesPerformance &&
            orderOfNamesPerformance.map((item, indx) => {
              return DynamicComponentGenerator(item);
            })}
          {activeTabName === "TAX AND LIQUIDITY" &&
            orderOfNamesTax &&
            orderOfNamesTax.map((item, indx) => {
              return DynamicComponentGenerator(item);
            })}

          {inputFields &&
            inputFields.map((item, indx) => {
              return DynamicComponentGenerator(item);
            })}
        </Styles.FormDiv>
        <div>
          <div
            style={{ paddingInline: "3rem", fontSize: "14px", color: "black" }}
          >
            {title &&
              title === "QUALIFIED ACCOUNT TYPE QUESTIONS" &&
              payload["Is Spouse or Partner Sole Beneficiary?"] === "true" && (
                <React.Fragment>
                  <div>*Please confirm these with a CPA.</div>
                  <ol>
                    <li>
                      Only a spouse beneficiary can roll over or transfer her
                      inherited IRA into her own IRA.
                    </li>
                    <li>There is no deadline for a spousal rollover.</li>
                    <li>
                      If the deceased spouse died on or after his required
                      beginning date, the year-of-death required distribution
                      has to be taken before a 60-day rollover is permitted.
                    </li>
                    <li>
                      However, an RMD can be transferred (trustee-to-trustee) to
                      another account and taken later in the year.
                    </li>
                  </ol>
                </React.Fragment>
              )}
          </div>
          <>
            {groupedFieldsPage(advancedInformation) == activeTabName &&
              Object.keys(advancedInformation).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(
                  advancedInformation[grpField]
                );

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (advancedInformation[grpField][ItemKey]["subType"]) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(advancedInformation)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel header={Object.keys(advancedInformation)[index]}>
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (
                              advancedInformation[grpField][ItemKey]["subType"]
                            ) {
                              case "array":
                                return SubFieldGenerator(
                                  advancedInformation[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  advancedInformation[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>
                  </>
                );
              })}
          </>
          {/*  */}
          {/*  */}
          {/*  */}
          <>
            {groupedFieldsPage(assetBeneficiaryAssignment) == activeTabName &&
              Object.keys(assetBeneficiaryAssignment).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(
                  assetBeneficiaryAssignment[grpField]
                );

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (
                    assetBeneficiaryAssignment[grpField][ItemKey]["subType"]
                  ) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(assetBeneficiaryAssignment)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel
                          header={
                            Object.keys(assetBeneficiaryAssignment)[index]
                          }
                        >
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (
                              assetBeneficiaryAssignment[grpField][ItemKey][
                                "subType"
                              ]
                            ) {
                              case "array":
                                return SubFieldGenerator(
                                  assetBeneficiaryAssignment[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  assetBeneficiaryAssignment[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>
                    <>
                      {collapseAssetBeneficiaryAssignment.map((obj, index) => (
                        <div style={{ margin: "0.5rem 3rem", width: "50rem" }}>
                          <Collapse>
                            <Panel
                              header={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>{`Asset Beneficiary Assignment ${
                                    index + 1
                                  }`}</span>
                                  <div
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      backgroundColor: "red",
                                      padding: "6px 12px",
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                      color: "white",
                                    }}
                                    onClick={() =>
                                      setCollapseAssetBeneficiaryAssignment(
                                        (prevObjects) =>
                                          prevObjects.filter(
                                            (_, i) => i !== index
                                          )
                                      )
                                    }
                                  >
                                    Remove
                                  </div>
                                </div>
                              }
                            >
                              {groupedFieldsItemKeys.map((ItemKey) => {
                                switch (
                                  assetBeneficiaryAssignment[grpField][ItemKey][
                                    "subType"
                                  ]
                                ) {
                                  case "array":
                                    return SubFieldGenerator(
                                      assetBeneficiaryAssignment[grpField][
                                        ItemKey
                                      ]
                                    );

                                    break;
                                  case "single":
                                    return SubFieldGenerator(
                                      assetBeneficiaryAssignment[grpField][
                                        ItemKey
                                      ]
                                    );
                                    break;

                                  default:
                                    return <h1>default type Detected</h1>;
                                    break;
                                }
                              })}
                            </Panel>
                          </Collapse>
                        </div>
                      ))}
                    </>
                    {activeTabName === "ASSET INFORMATION" &&
                    assetBeneficiaryAssignment ? (
                      <div
                        onClick={handleNewAssetBeneficiaryAssignment}
                        style={{
                          backgroundColor: "#2A3DA3",
                          padding: "10px 20px",
                          borderRadius: "10px",
                          float: "left",
                          margin: "1% 3rem",
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        Add +
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
          </>
          {/*  */}
          {/*  */}
          <>
            {groupedFieldsPage(ContributionOrDistribution) == activeTabName &&
              Object.keys(ContributionOrDistribution).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(
                  ContributionOrDistribution[grpField]
                );

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (
                    ContributionOrDistribution[grpField][ItemKey]["subType"]
                  ) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(ContributionOrDistribution)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel
                          header={
                            Object.keys(ContributionOrDistribution)[index]
                          }
                        >
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (
                              ContributionOrDistribution[grpField][ItemKey][
                                "subType"
                              ]
                            ) {
                              case "array":
                                return SubFieldGenerator(
                                  ContributionOrDistribution[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  ContributionOrDistribution[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>

                    <>
                      {collapseContributionOrDistribution.map((obj, index) => (
                        <div style={{ margin: "0.5rem 3rem", width: "50rem" }}>
                          <Collapse>
                            <Panel
                              header={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>{`Additional Principal Payments ${
                                    index + 1
                                  }`}</span>
                                  <div
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      backgroundColor: "red",
                                      padding: "6px 12px",
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                      color: "white",
                                    }}
                                    onClick={() =>
                                      setCollapseContributionOrDistribution(
                                        (prevObjects) =>
                                          prevObjects.filter(
                                            (_, i) => i !== index
                                          )
                                      )
                                    }
                                  >
                                    Remove
                                  </div>
                                </div>
                              }
                            >
                              {groupedFieldsItemKeys.map((ItemKey) => {
                                switch (
                                  ContributionOrDistribution[grpField][ItemKey][
                                    "subType"
                                  ]
                                ) {
                                  case "array":
                                    return SubFieldGenerator(
                                      ContributionOrDistribution[grpField][
                                        ItemKey
                                      ]
                                    );

                                    break;
                                  case "single":
                                    return SubFieldGenerator(
                                      ContributionOrDistribution[grpField][
                                        ItemKey
                                      ]
                                    );
                                    break;

                                  default:
                                    return <h1>default type Detected</h1>;
                                    break;
                                }
                              })}
                            </Panel>
                          </Collapse>
                        </div>
                      ))}
                    </>
                    {activeTabName === "CONTRIBUTIONS OR DISTRIBUTIONS" &&
                    ContributionOrDistribution ? (
                      <div
                        onClick={handleNewContributionOrDistribution}
                        style={{
                          backgroundColor: "#2A3DA3",
                          padding: "10px 20px",
                          borderRadius: "10px",
                          float: "left",
                          margin: "1% 3rem",
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        Add +
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
          </>
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}

          <>
            {groupedFieldsPage(liveStock) == activeTabName &&
              Object.keys(liveStock).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(liveStock[grpField]);

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (liveStock[grpField][ItemKey]["subType"]) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(liveStock)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel header={Object.keys(liveStock)[index]}>
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (liveStock[grpField][ItemKey]["subType"]) {
                              case "array":
                                return SubFieldGenerator(
                                  liveStock[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  liveStock[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>
                  </>
                );
              })}
          </>
          <>
            <>
              {groupedFieldsPage(stockMarket) == activeTabName && (
                <div style={{ paddingInline: "2rem" }}>
                  {/* <List cols={Stockcols} rows={stockList}></List> */}
                  <div className="stockCard" style={{ position: "relative" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3 className="stockReportheading">
                        $
                        {(stockGain &&
                          (stockGain.closeBasis || stockGain.cashHolding)) ||
                        payload["Cash Holding"] ||
                        (attributeValues &&
                          attributeValues["Cash Holding"] !== null &&
                          attributeValues["Cash Holding"])
                          ? (
                              (stockGain && stockGain.closeBasis
                                ? stockGain.closeBasis
                                : 0) +
                              (stockGain && stockGain.cashHolding
                                ? stockGain.cashHolding
                                : 0) +
                              (attributeValues &&
                              attributeValues["Cash Holding"] !== undefined &&
                              attributeValues["Cash Holding"] !== "" &&
                              attributeValues["Cash Holding"] !== null
                                ? +attributeValues["Cash Holding"]
                                : payload &&
                                  payload["Cash Holding"] !== undefined &&
                                  payload["Cash Holding"] !== ""
                                ? +payload["Cash Holding"]
                                : 0)
                            )
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </h3>
                      {!view && (
                        <DropDown1
                          trigger={["click"]}
                          overlay={
                            <Menu>
                              <Menu.Item>
                                <div
                                  onClick={() => {
                                    console.log("edit");
                                    setEditCashHoldindg(true);
                                  }}
                                >
                                  Edit
                                </div>
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <div
                            onClick={(e) => e.preventDefault()}
                            style={{
                              cursor: "pointer",
                              marginRight: "1rem",
                              padding: "0px 16px",
                              width: "5px",
                            }}
                          >
                            <a className="ant-dropdown-link">
                              <img
                                src={menuIcon}
                                height={15}
                                width={4}
                                alt="icon"
                              ></img>
                            </a>
                          </div>
                        </DropDown1>
                      )}
                    </div>
                    <div className="stockRow">
                      <div>
                        <div className="stockReportrow2">
                          <div
                            className="stockReportrowData"
                            style={{
                              flexDirection: "row",
                              width: "100%",
                              alignItems: "center",
                            }}
                          >
                            <span className="stockReportTitle">
                              {" "}
                              Cash Holding{" "}
                            </span>
                            {
                              editCashHoldindg ? (
                                <div
                                  className="inputWrapper"
                                  style={{ display: "flex" }}
                                >
                                  <span className="dollarSymbol">$</span>
                                  <InputNumber
                                    step={1}
                                    formatter={(value) =>
                                      `${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )
                                    }
                                    parser={(value) =>
                                      value.replace(/\$\s?|(,*)/g, "")
                                    }
                                    className="Input"
                                    placeholder="Cash Holding"
                                    name="Cash Holding"
                                    onPressEnter={handleKeyPress}
                                    value={
                                      payload &&
                                      payload["Cash Holding"] !== undefined
                                        ? payload["Cash Holding"]
                                        : attributeValues &&
                                          attributeValues["Cash Holding"] !==
                                            undefined &&
                                          attributeValues["Cash Holding"] !==
                                            null
                                        ? attributeValues &&
                                          attributeValues["Cash Holding"]
                                        : stockGain &&
                                          stockGain.cashHolding !== undefined
                                        ? stockGain.cashHolding.toFixed(2)
                                        : ""
                                    }
                                    id="cashHolding"
                                    onChange={(value) => {
                                      handleInputFields("Cash Holding", value);
                                      if (
                                        attributeValues &&
                                        attributeValues["Cash Holding"] &&
                                        attributeValues["Cash Holding"] !== null
                                      ) {
                                        attributeValues["Cash Holding"] = value;
                                      }
                                    }}
                                  />
                                </div>
                              ) : (
                                <div className="stockReportsubTitle2">
                                  $
                                  {payload &&
                                  payload["Cash Holding"] !== undefined
                                    ? payload["Cash Holding"]
                                        .toFixed(2)
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : attributeValues &&
                                      attributeValues["Cash Holding"] !==
                                        null &&
                                      attributeValues["Cash Holding"] !==
                                        undefined
                                    ? attributeValues &&
                                      attributeValues["Cash Holding"]
                                        .toFixed(2)
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : stockGain &&
                                      stockGain.cashHolding !== undefined
                                    ? stockGain.cashHolding
                                        .toFixed(2)
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : "0.00"}
                                </div>
                              )
                              /* <div className="stockReportsubTitle2">
                              $
                              {stockGain && stockGain.cashHolding
                                ? (stockGain.cashHolding)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : 0}
                            </div> */
                            }
                          </div>
                        </div>
                        {/* <div
                          className="stockReportrow1"
                          style={{ marginTop: "1rem" }}>
                          <div
                            className="stockReportrowData"
                            style={{ flexDirection: "row", width: "100%" }}>
                            <span className="stockReportTitle">Day Gain</span>
                            <div
                              className="stockReportsubTitle2"
                              style={{
                                color:
                                  stockGain && stockGain.dayGain > 0
                                    ? "green"
                                    : "red",
                              }}>
                              {" "}
                              $
                              {stockGain && stockGain.dayGain
                                ? (stockGain && stockGain.dayGain)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : 0}
                              <span
                                style={{
                                  color:
                                    stockGain &&
                                    stockGain.gainLossDayPercentage > 0
                                      ? "green"
                                      : "red",
                                }}>
                                {" "}
                                (
                                {stockGain &&
                                  stockGain.gainLossDayPercentage &&
                                  stockGain.gainLossDayPercentage.toFixed(2)}
                                ) %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="stockReportrow2">
                          <div
                            className="stockReportrowData1"
                            style={{ flexDirection: "row", width: "100%" }}>
                            <span className="stockReportTitle">Total Gain/Loss</span>
                            <div
                              className="stockReportsubTitle2"
                              style={{
                                color:
                                  stockGain && stockGain.totalPercentageGainorLossvalue > 0
                                    ? "green"
                                    : "red",
                              }}>
                              {" "}
                              $
                              {stockGain && stockGain.totalPercentageGainorLossvalue
                                ? stockGain.totalPercentageGainorLossvalue
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                : 0}
                              <span
                                style={{
                                  color:
                                    stockGain &&
                                    stockGain.totalPercentageGainorLoss > 0
                                      ? "green"
                                      : "red",
                                }}>
                                {" "}
                                (
                                {stockGain &&
                                  stockGain.totalPercentageGainorLoss &&
                                  stockGain.totalPercentageGainorLoss.toFixed(2)}
                                ) %
                              </span>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <NewLoader isLoading={loadingStocks} />
                  </div>
                  <div className="stockAdd">
                    <label>Your Portfolio</label>
                    <Styles.SubFormDiv
                      style={{
                        marginTop: "0.5rem",
                      }}
                    >
                      <div className="stockLabel">
                        <label>Add Ticker Symbol</label>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Styles.InputBorder>
                          <input
                            type="text"
                            disabled={view}
                            style={{
                              outline: "none",
                              border: "none",
                              width: "98%",
                              // marginTop:"0.5rem"
                            }}
                            onChange={(e) => {
                              handleInputStock(e.target.value, "tickerSymbol");
                            }}
                            value={
                              stockSymbolData && stockSymbolData.tickerSymbol
                                ? stockSymbolData.tickerSymbol.toUpperCase()
                                : ""
                            }
                            // value={
                            //   payload[item.name]
                            //     ? payload[item.name]
                            //     : attributeValues[item.name]
                            //     ? attributeValues[item.name]
                            //     : ""
                            // }
                          />
                          <div
                            className="upload"
                            style={{
                              width: "50px",
                              height: "100%",
                              cursor: "pointer",
                              borderRadius: "8px",
                              opacity:
                                stockSymbolData && stockSymbolData.tickerSymbol
                                  ? 1
                                  : "0.3",
                              cursor:
                                stockSymbolData && stockSymbolData.tickerSymbol
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                            onClick={() => {
                              if (
                                stockSymbolData &&
                                stockSymbolData.tickerSymbol
                              ) {
                                addStockSymbol();
                              }
                            }}
                          >
                            <img
                              src={addIcon1}
                              width={12}
                              height={12}
                              style={{ width: "14px", height: "14px" }}
                              alt="addicon"
                            ></img>
                          </div>
                        </Styles.InputBorder>
                      </div>
                    </Styles.SubFormDiv>
                  </div>
                  <div
                    style={{
                      background: "white",
                      paddingInline: "2rem",
                      position: "relative",
                    }}
                  >
                    <NestedTable
                      StockData={stockList && stockList}
                      expandedData={expandedTableData && expandedTableData}
                    />
                    <NewLoader isLoading={loadingStocks} />
                  </div>
                  {expandedRow && (
                    <div style={{ width: "50%" }}>
                      <div style={{ marginBottom: "8px" }}>
                        <h3 className="inputTitle">Buy/Sell</h3>
                        <Select
                          showSearch
                          placeholder="-Select-"
                          value={stockBuyData && stockBuyData.buySell}
                          onChange={(value, id) => {
                            handleStockChange("buySell", value);
                          }}
                        >
                          {[{ name: "Buy" }, { name: "Sell" }].map(
                            (item, index) => (
                              <Option key={index} value={item.name}>
                                {item.name}
                              </Option>
                            )
                          )}
                        </Select>
                      </div>
                      <div style={{ marginBottom: "8px" }}>
                        <h3 className="inputTitle">Trade Date</h3>
                        <DatePicker
                          style={{
                            width: "100%",
                            border: "1px solid #d1d5db",
                            borderRadius: "5px",
                          }}
                          size="large"
                          format={"MM/DD/YYYY"}
                          placeholder="Trade Date"
                          name="tradeDate"
                          value={
                            stockBuyData &&
                            stockBuyData.tradeDate &&
                            moment.utc(stockBuyData.tradeDate)
                          }
                          id="newDate"
                          onChange={(date, dateString) => {
                            handleStockChange("tradeDate", dateString);
                          }}
                        />
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <h3 className="inputTitle">Shares</h3>
                        <input
                          className="roleInput"
                          placeholder="Shares"
                          name="shares"
                          value={stockBuyData && stockBuyData.shares}
                          id="shares"
                          onChange={(e) => {
                            e.preventDefault();
                            handleStockChange(e.target.name, e.target.value);
                          }}
                        />
                      </div>
                      <div style={{ marginBottom: "8px" }}>
                        <h3 className="inputTitle">Price Per Share</h3>
                        <div
                          className="inputWrapper"
                          style={{ display: "flex" }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              padding: "8px",
                              display: "flex",
                              alignItems: "center",
                              color: "rgba(0, 0, 0, 0.65)",
                              background: "#fafafa",
                              borderRadius: "4px",
                              border: "1px solid #d1d5db",
                            }}
                          >
                            $
                          </span>
                          <InputNumber
                            step={1}
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                            className="Input"
                            placeholder="Price Per Share"
                            name="pricePerShare"
                            value={stockBuyData && stockBuyData.pricePerShare}
                            // id="amount"
                            onChange={(value) => {
                              handleStockChange("pricePerShare", value);
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: "8px" }}>
                        <h3 className="inputTitle">Commission</h3>
                        <Radio.Group
                          buttonStyle="solid"
                          name="commissionType"
                          value={stockBuyData && stockBuyData.commissionType}
                          defaultValue={"Percent"}
                          onChange={(e) => {
                            handleStockChange(e.target.name, e.target.value);
                          }}
                        >
                          {["Percent", "Flat Fee"].map((value, vindex) => (
                            <Radio.Button key={vindex} value={value}>
                              {value}
                            </Radio.Button>
                          ))}
                        </Radio.Group>
                      </div>
                      <div style={{ marginBottom: "8px" }}>
                        {stockBuyData &&
                        stockBuyData.commissionType === "Flat Fee" ? (
                          <div
                            className="inputWrapper"
                            style={{ display: "flex" }}
                          >
                            <span className="dollarSymbol">$</span>
                            <InputNumber
                              step={1}
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                              }
                              className="Input"
                              placeholder="Commission"
                              name="commission"
                              value={stockBuyData && stockBuyData.commission}
                              id="commission"
                              onChange={(value) => {
                                handleStockChange("commission", value);
                              }}
                            />
                          </div>
                        ) : (
                          <input
                            className="roleInput"
                            placeholder="Percentage"
                            name="commission"
                            value={stockBuyData && stockBuyData.commission}
                            id="commission"
                            onChange={(e) => {
                              e.preventDefault();
                              handleStockChange(e.target.name, e.target.value);
                            }}
                          />
                        )}
                      </div>
                      <button
                        className="addbuttonassets"
                        onClick={(e) => {
                          if (stockUpdate) {
                            handleUpdateStockBuy(e);
                          } else {
                            handleAddStockBuy(e);
                          }
                        }}
                      >
                        {" "}
                        {stockUpdate ? "Update" : "+ Add"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </>
            {/* 
            {groupedFieldsPage(stockMarket) == activeTabName &&
              Object.keys(stockMarket).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(
                  stockMarket[grpField]
                );

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (stockMarket[grpField][ItemKey]["subType"]) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(stockMarket)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel header={Object.keys(stockMarket)[index]}>
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (stockMarket[grpField][ItemKey]["subType"]) {
                              case "array":
                                return SubFieldGenerator(
                                  stockMarket[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  stockMarket[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>
                    {activeTabName === "ADDITIONAL ASSET INFORMATION" &&
                    stockMarket ? (
                      <div
                        onClick={handleAddStockSymbol}
                        style={{
                          backgroundColor: "#2A3DA3",
                          padding: "10px 20px",
                          borderRadius: "10px",
                          float: "left",
                          margin: "1% 3rem",
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        Add +
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
                */}
          </>
          <>
            {(payload["Is this your primary residence?"] === "false" ||
              payload["Is this your primary residence?"] === false ||
              attributeValues["Is this your primary residence?"] === "false" ||
              attributeValues["Is this your primary residence?"] === false) &&
              groupedFieldsPage(investmentProperty) == activeTabName &&
              Object.keys(investmentProperty).map((grpField, index) => {
                const groupedFieldsItemKeys = Object.keys(
                  investmentProperty[grpField]
                );

                groupedFieldsItemKeys.map((ItemKey) => {
                  switch (investmentProperty[grpField][ItemKey]["subType"]) {
                    case "array":
                      return (
                        <>
                          <h1>array type Detected</h1>
                        </>
                      );
                      break;
                    case "single":
                      return (
                        <>
                          <h1>single type Detected</h1>
                        </>
                      );
                      break;

                    default:
                      return <h1>default type Detected</h1>;
                      break;
                  }
                });

                return (
                  <>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: " 2rem  3rem",
                        color: "#030229",
                      }}
                    >
                      {Object.keys(investmentProperty)[index]}
                    </h1>
                    <div style={{ margin: " 0 3rem", width: "50rem" }}>
                      <Collapse>
                        <Panel header={Object.keys(investmentProperty)[index]}>
                          {groupedFieldsItemKeys.map((ItemKey) => {
                            switch (
                              investmentProperty[grpField][ItemKey]["subType"]
                            ) {
                              case "array":
                                return SubFieldGenerator(
                                  investmentProperty[grpField][ItemKey]
                                );

                                break;
                              case "single":
                                return SubFieldGenerator(
                                  investmentProperty[grpField][ItemKey]
                                );
                                break;

                              default:
                                return <h1>default type Detected</h1>;
                                break;
                            }
                          })}
                        </Panel>
                      </Collapse>
                    </div>
                    <>
                      {collapseinvestment.map((obj, index) => (
                        <div style={{ margin: "0.5rem 3rem", width: "50rem" }}>
                          <Collapse>
                            <Panel
                              header={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>{`Investment Property Expenses ${
                                    index + 1
                                  }`}</span>
                                  <div
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      backgroundColor: "red",
                                      padding: "6px 12px",
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                      color: "white",
                                    }}
                                    onClick={() =>
                                      setCollapseInvestment((prevObjects) =>
                                        prevObjects.filter(
                                          (_, i) => i !== index
                                        )
                                      )
                                    }
                                  >
                                    Remove
                                  </div>
                                </div>
                              }
                            >
                              {groupedFieldsItemKeys.map((ItemKey) => {
                                switch (
                                  investmentProperty[grpField][ItemKey][
                                    "subType"
                                  ]
                                ) {
                                  case "array":
                                    return SubFieldGenerator(
                                      investmentProperty[grpField][ItemKey]
                                    );

                                    break;
                                  case "single":
                                    return SubFieldGenerator(
                                      investmentProperty[grpField][ItemKey]
                                    );
                                    break;

                                  default:
                                    return <h1>default type Detected</h1>;
                                    break;
                                }
                              })}
                            </Panel>
                          </Collapse>
                        </div>
                      ))}
                    </>
                    {activeTabName === "ADDITIONAL ASSET INFORMATION" &&
                    investmentProperty ? (
                      <div
                        onClick={handleNewInvestment}
                        style={{
                          backgroundColor: "#2A3DA3",
                          padding: "10px 20px",
                          borderRadius: "10px",
                          float: "left",
                          margin: "1% 3rem",
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        Add +
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
          </>
        </div>
      </>
      <NewLoader isLoading={loading} />
    </div>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  currentTab,
  activeTabName,
  setActiveTabName,
  activeStep1,
  AllTabs,
  // module,
}) => {
  const [alltabs, setAllTabs] = useState(AllTabs);
  const [tabNames, setTabNames] = useState([]);
  const [activeStep, setActiveStep] = useState(activeStep1);

  useEffect(() => {
    let temp = tabs.map((tab) => tab.toUpperCase());
    setTabNames(temp);
  }, [tabs]);
  useEffect(() => {
    let temp2 = Object.keys(alltabs);
    temp2.map((tab) => {
      if (tabNames.includes(tab)) {
        setAllTabs((prevValue) => ({
          ...prevValue,
          [tab]: { ...prevValue[tab], enabled: true },
        }));
      }
    });
  }, [tabs]);

  useEffect(() => {
    console.log("alltabs", alltabs);
  }, [alltabs]);
  useEffect(() => {
    console.log("tabs", tabs);
    setActiveStep(activeStep1);
  }, [tabs, activeStep1]);
  return (
    <div>
      <Styles.TabContainer>
        {Object.keys(alltabs).map((tabName, tabIndex) => {
          return (
            <Fragment key={tabIndex}>
              {tabIndex > 0 && (
                <Styles.SpacerLine
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                ></Styles.SpacerLine>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "70px",
                }}
              >
                <Styles.TabBox
                  onClick={() => {
                    if (alltabs[tabName].enabled) {
                      currentTab(alltabs[tabName].name);
                      setActiveTabName(alltabs[tabName].name);
                      setActiveStep(tabIndex);
                    }
                  }}
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                  activeStep1={activeStep1}
                  activeTabIndex={activeTabIndex}
                  isActive={alltabs[tabName].name == activeTabName}
                  isEnabled={alltabs[tabName].enabled}
                >
                  <Styles.TabBoxNumber>
                    {alltabs[tabName].priority}
                  </Styles.TabBoxNumber>
                </Styles.TabBox>
                <p style={{ margin: "10px 0", textAlign: "center" }}>
                  {alltabs[tabName].name}
                </p>
              </div>
            </Fragment>
          );
        })}
      </Styles.TabContainer>
    </div>
  );
};

export default AllocationSubform;
